module.exports = {
    "en": {
        common: {
            YES: 'Yes',
            NO: 'No',
            NOT_APPLICABLE: 'N/A',
            NO_DATA: 'No Data',
            NONE: 'None',
            UNKNOWN: 'Unknown',
            NEVER: 'Never',
            EDIT: 'Edit',
            STOP_EDITING: 'Stop Editing',
            UPDATE: 'Update',
            SEARCH: 'Search',
            NO_RESULT_SEARCH: 'No results for search',
            SELECTED_NM_SEARCH: 'Selected not matching search',
            SEARCH_INSTRUCTIONS: 'Entering text and pressing the Search button will update the content.',
            SEARCH_RESULTS_UPDATED: 'The search results have been updated',
            OPEN_NEW_TAB: 'Open in new tab',
            DOWNLOAD: 'Download',
            COPY_SUCCESSFUL: "Copy Successful",
            MAX: "Max",
            CONFIRM: "Confirm",
            CONFIRM_LC: "confirm",
            CONFIRM_DECISION: "Confirm Decision",
            CLOSE: "Close",
            CLOSE_LC: "close",
            CANCEL: "Cancel",
            CANCEL_LC: "cancel",
            CONTINUE: "Continue",
            SUBMIT: "Submit",
            LOADING: "Loading",
            ADD: "Add",
            EXPORT_CSV: "Export CSV",
            IMPORT_CSV: "Import CSV",
            NOT_ALLOWED: "Not allowed",
            BACK: "Back",
            DELETE: "Delete",
            DELETE_LC: "delete",
            REMOVE: "Remove",
            CREATED: "Created",
            CREATED_AT: "Created At",
            MODIFIED: "Modified",
            LAST_UPDATED: "Last Updated",
            AVAILABLE: "Available",
            EDIT_LC: "edit",
            COPY_LC: "copy",
            MOVE_LC: "move",
            ITEM_COPY_DEF_POST: " Copy",
            SEL_DEST_PROJ: "Select a destination project:",
            DATE: "Date",
            START_DATE: "Start Date",
            END_DATE: "End Date",
            START_TIME: "Start Time",
            END_TIME: "End Time",
            EXP_COLL: "Expand/Collapse",
            EXP_COLL_ACTIVITY: "Expand/Collapse Activity",
            ACTIVITY_DETAILS: "Activity Details",
            LOG_OUT: "Log Out",
            FILTER: "Filter",
            SKILLBUILD: "SkillBuild",
            COMING_SOON: "Coming Soon",
            MUZZY_LANE: "Muzzy Lane",
            MUZZY_LANE_AUTHOR: "Muzzy Lane Author",
            TRUE: 'True',
            FALSE: 'False',
            DONT_CARE: "Don't Care",
            DEPRECATED_UC: "DEPRECATED",
            REPORT: "Report",
            AUTHOR: "Author",
            UNASSIGNED: "Unassigned",
            OWNER: "Owner",
            ENABLED: "Enabled",
            ENABLE: "Enable",
            DISABLED: "Disabled",
            DISABLE: "Disable",
            ID: "ID",
            STATUS: "Status",
            PREVIEW: "Preview",
            ACTIONS: "Actions",
            DETAILS: "Details",
            TOTALS: "Totals",
            ERROR: "Error",
            SHOW_DATA: "Show Data",
            HIDE_DATA: "Hide Data",
            HELP: "Help",
            ON: "On",
            OFF: "Off",
            PICK_DATE: "Pick Date",
            PICK_TIME: "Pick Time",
        },
        activity: {
            ACTIVITY: 'Activity',
            ACTIVITIES: 'Activities',
            ACTIVITY_NAME: 'Activity Name',
            DESCRIPTION_SHORT: 'Description',
            NO_DESCRIPTION: 'No description',
            VERSION: "Version",
            UNTITLED_ACT: 'Untitled Activity',
            IMPORT_SAVE_MSG: 'Imported activity',
            UNPUBLISH_WARNING: 'This will unpublish ALL currently published activity versions. Assignments using this activity will no longer be accessible. This cannot be undone.',
            PUBLISH_MSG: 'Publish message',
            ORIG_PUBLISH_MSG: 'Original publish message',
            IS_UNPUBLISHED: 'This version has been unpublished.',
            UNPUBLISHED_ON: 'Unpublished on',
            UNPUBLISHED_BY: 'Unpublished by',
            SAVE_PUBLISH_HISTORY: 'Save & Publish History',
            TOTAL_CREATED: 'Total Created',
            TOTAL_SHARED: 'Total Shares',
            UNIQUE_SHARED_MTD: 'Unique Shares MTD',
            UNIQUE_SHARED_MTD_TT: 'Number of unique users launching a share link in the current month',
            LAST_PUBLISHED: 'Last Published',
            CURRENT_VERSION: 'Current Version',
            TEMPLATE: 'Template',
            actions: {
                EDIT: "edit",
                REVIEW: "review",
                REVIEW_TT: "Enter the editor for this activity in read only mode (will not block other editors)",
                PREVIEW: "preview",
                PREVIEW_TT: "Preview last saved version of this activity as a student",
                PUBLISH: "publish",
                UNPUBLISH: "unpublish",
                DUPLICATE: "duplicate activity",
                RENAME: "rename activity",
                MOVE: "move activity",
                DELETE: "delete",
                MANAGE_IT: "manage integration tags",
                MANAGE_MT: "manage meta tags",
                ANALYTICS: "activity analytics",
                IMPORT_OVER: "import activity over",
                COURSE_META: "course metadata",
                EDL_EXPORT: "EDL analytics export",
                EDL_EXPORT_PENDING: "Exporting...",
                EDL_EXPORT_DL: "Download EDL export",
                EDL_EXPORT_LATEST_SUF: " (latest)",
            },
            display_name: {
                ACT_DISPLAY_NAME: "Activity Display Name",
                DISPLAY_NAME_DESC: "When present, the Activity Display Name will be used in place of the Activity Name in the context of Assignments.",
                UL_HEAD: "Examples:",
                UL_1: "LTI Instructors choosing an activity for an assignment will see the Activity Display Name.",
                UL_2: "Students taking an assignment using the activity will see the Activity Display Name.",
            },
            description: {
                ACT_DESCRIPTION: "Activity Description",
                ACT_DESC_DESC: "When present, the Activity Description will be shown in student & teacher assignment views.",
                TA_PLACEHOLDER: "Write a description of your activity here",
            },
            play_button: {
                PB_TEXT: "Play Button Text",
                PB_TEXT_DESC: "The text on the button to play this activity in a student assignment.",
                PB_PLACEHOLDER: "Play Assignment",
                RB_PLACEHOLDER: "Resume Assignment",
            },
            image: {
                ALT: "Custom Activity Image",
                BTN_TEXT: "Upload Activity Image",
            },
            stats: {
                ACT_STATS: "Activity Statistics",
                COMPLETED_TITLE: "Completed",
                COMPLETED_TT: "The total number of times this activity has been completed and the % completion rate",
                TP_TITLE: "Average Time Played",
                TP_TT: "The average time it took to complete this activity (hh:mm:ss)",
                SCR_TITLE: "Average Score",
                SCR_TT: "The average normalized score (0-100%) of completed games",
            },
            publish: {
                MODAL_HEADER: "Publish Activity",
                BLOCKED_BY_LOCK: "Cannot publish while activity is locked.",
                CHECKING_MSG: "Checking version compatibility and validating activity...",
                UPDATE_INACTIVE_ASSN: "Update inactive assignments",
                UPDATE_ACTIVE_ASSN: "Update compatible active assignments",
                TT_UPDATE_INACTIVE: "Inactive assignments have not been started by any students.",
                TT_UPDATE_ACTIVE: "Active assignments have been started by at least one student. Assignments are considered compatible if they use an older matching version of this activity.",
                VERSION_UPDATED_TO: "The version will be updated to",
                CONFIRM_HEADING: "Confirm Publish Activity",
                CONFIRM_PROMPT: "Please confirm publishing activity. The following changes will occur:",
                CONFIRM_INACTIVE_UPDATE_TRUE: "Inactive assignments WILL be updated",
                CONFIRM_INACTIVE_UPDATE_FALSE: "Inactive assignments WILL NOT be updated",
                CONFIRM_ACTIVE_UPDATE_TRUE: "Compatible active assignments WILL be updated",
                CONFIRM_ACTIVE_UPDATE_FALSE: "Active assignments WILL NOT be updated",
                CONFIRM_BUTTON: "confirm publish",
            },
            saves: {
                THEAD_SAVE: "Save",
                THEAD_PUBLISH: "Publish",
                THEAD_VERSION: "Version",
                THEAD_SAVE_USER: "User",
                THEAD_SAVE_DATE: "Date",
                THEAD_SAVE_MSG: "Msg.",
                THEAD_PUB_USER: "User",
                THEAD_PUB_DATE: "Date",
                THEAD_PUB_MSG: "Msg.",
                TABLE_CURRENT_VERSION: "This is the current version.",
                TABLE_VALIDATION_RPT: "Validation Report"
            },
            qla: {
                QLA_TITLE: "Question-level Analytics",
                QLA_TITLE_LC: "question-level analytics",
                act_version: {
                    CUS_VER_RANGE: "Custom Version Range",
                    VER_NONE: "None",
                    RANGE_TO: "to",
                    DISP_VER_RANGE: "Displayed Version Range",
                    CMP_VER_LOG: "Published Versions",
                    CMP_VER_LOG_TT: "When an activity is changed and published, a new version of the activity is created. If any of element of the activity’s scoring system is changes, the new version of the activity will not be compatible with older versions. The controls below allow you to pull data from specific compatible version ranges. Choose the starting version on the left and the ending version on the right and click update. The table on the right shows the current displayed set of versions in bold and separates incompatible sets of versions with a horizontal line.",
                    THEAD_VERSION: "Version",
                    THEAD_PUB_USER: "Name",
                    THEAD_PUB_DATE: "Date",
                    THEAD_PUB_MSG: "Msg.",
                    THEAD_PUB_NUM_COMPLETED: "# Completed",

                },
                charts: {
                    OVR_ACT_STATS: "Overall Activity Statistics",
                    LO_USAGE: "Learning Objectives",
                    CH_TYPE: "Chart Type",
                    CH_TYPE_PIE: "Pie",
                    CH_TYPE_BAR: "Bar",
                    CH_TITLE_COMPLETED: "Completed",
                    CH_TITLE_TP: "Time Played",
                    CH_TITLE_SCORE: "Overall Score",
                    CH_TITLE_SC: "Overall Score Makeup",
                    CH_TT_COMPLETED: "The total number of times this activity has been completed and the % completion rate.",
                    CH_TT_TP: "The distribution of time played for all submitted attempts and average time for completion displayed as HH:MM:SS.",
                    CH_TT_SCORE: "The overall score distribution for all submitted attempts and the average overall score for all submitted attempts. Overall score represents the Combined/Roll-up Score and is calculated using the authored objectives for the activity.",
                    CH_TT_SC: "The distribution of the weighted objectives used to calculate the Overall Score of the activity. Note: Very rarely objectives may be calculated using an aggregate expression, in which case the graph will be labeled N/A.",
                    CH_TT_LO: "The learning objective score distribution for all attempts and the average learning objective score.",
                },
                los: {
                    NO_OBJECTIVES: "No objectives present in activity",
                },
                questions: {
                    Q_R_DATA: "Question and Response Data",
                    Q_R_NO_QUESTIONS: "No questions for activity",
                    QA_THEAD_Q_PROMPT: "Question Prompt",
                    QA_THEAD_Q_TYPE: "Type",
                    QA_THEAD_QUALITY: "Factual or Opinion",
                    QA_THEAD_LOOP: "Loop on Incorrect",
                    QA_THEAD_TOTAL_ANS: "Total Answers",
                    QA_THEAD_PCT_CORRECT: "Percent Correct",
                    QA_THEAD_TS: "Time Spent",
                    QA_THEAD_NO_DET_FOR_TYPE: "Not available for question type",
                    QA_THEAD_Q_TYPE_TT: "Question types are abbreviated as follows: MCQ: Multiple Choice Question, FITB-A: Fill in the Blank-Assess, FITB-S: Fill in the Blank-Store, SATA: Select all that Apply, CAT: Categorize, LIKE: Likert, RANK: Ranked, MAT: Match",
                    QA_THEAD_QUALITY_TT: "Factual questions have correct answers. Opinion questions do not have correct answers but still impact scoring if points have been allocated.",
                    QA_THEAD_LOOP_TT: "Loop on Incorrect requires a student to respond to a question until they get the right answer or have reached the maximum number of attempts for the question. Each time a response is submitted, it counts as an attempt at the question.",
                    QA_THEAD_TOTAL_ANS_TT: "The number of times a question was answered. This number may vary in activities with branching.",
                    QA_THEAD_PCT_CORRECT_TT: "The percentage of time that the question was answered correctly. Colors indicate the difficulty designation of the question based on this percentage. 0-19% = very difficult (red); 20-59% = difficult (orange); 60-89% = moderately difficult (yellow); 90-100% = easy (green).",
                    QA_THEAD_TS_TT: "The average amount of time spent answering a question. This is tracked from the time the question is presented through when the response is submitted.",
                    QS_THEAD_RESPONSE: "Response",
                    QS_THEAD_CORRECT: "Correct?",
                    QS_THEAD_CORRECT_TT: "Factual responses show Yes or No to indicate if they are correct. Opinion questions show N/A, though they can still count toward scoring if points are assigned.",
                    QS_THEAD_STUD_SHLD_SEL: "Student Should Select?",
                    QS_THEAD_STUD_SHLD_SEL_TT: 'Note: Applicable to Select all that Apply only. Indicates whether the response should be selected or not as a correct answer. Points are gained for selecting a response when “Yes” is listed but points are missed if they don’t select it when it should be selected. Points are gained for leaving a response unselected when “No” is listed but missed if they select it when it should not be selected.',
                    QS_THEAD_COUNT: "Count",
                    QS_THEAD_COUNT_TT: "The number of times that each response was chosen and submitted by students.",
                    QS_THEAD_COUNT_ATAQ_TT:  "The number of times that each response was chosen and submitted.",
                    QS_THEAD_PERCENT: "Percent",
                    QS_THEAD_PERCENT_TT: "The percentage of time that this response was selected and submitted.",
                    QS_THEAD_PERCENT_CAT_TT: "The percentage of time that each response was put into its correct category and submitted. Colors indicate the difficulty designation of the question based on this percentage. 0-19% = very difficult (red); 20-59% = difficult (orange); 60-89% = moderately difficult (yellow); 90-100% = easy (green).",
                    QS_THEAD_TS: "Time Spent",
                    QS_THEAD_TS_TT: "The average amount of time spent selecting the response. This is tracked from the time the question is presented through when the response is submitted.",
                    QS_THEAD_LO_TT: "The points scored for selection of this response and submission as an answer for this learning objective.",
                    QS_TD_DISTRACTORS: "Distractors",
                    QA_TD_CATEGORIES: "Categories",
                },
            },
            share: {
                ACT_SHARE_TITLE: 'Sharing',
                ENABLE_SHARE: 'Enable Sharing',
                DISABLE_SHARE: 'Disable Sharing',
                SHARE_LINK: 'Share Link',
                EXPIRATION_LABEL: 'Share Link Expiration',
                UPDATE_EXPIRATION: 'Update Expiration',
                REMOVE_EXPIRATION: 'Remove Expiration',
                DIRECT_LINK: 'Direct Link (for sharing)',
                DIRECT_LINK_DEP: 'This method of sharing is deprecated and will cease support on 8/31/24. Please use Share Link instead.',
            },
        },
        short_course: {
            SHORT_COURSE: "Short Course",
            SHORT_COURSES: "Short Courses",
            UNPUBLISHED_NOTICE: "This course is no longer available. Please contact your instructor to receive a replacement course.",
            INVALID_INSTANCE_ROLE: "Invalid role for course.",
            DELETE_WARNING: "Are you sure you would like to delete this course? All related course instances will be deleted. This cannot be undone.",
            ORIG_PUBLISH_MSG: 'Original publish message',
            UNPUBLISH_WARNING: 'This will unpublish ALL currently published course versions. Course instances using this course will no longer be accessible. This cannot be undone.',
            IS_UNPUBLISHED: 'This version has been unpublished.',
            UNPUBLISHED_ON: 'Unpublished on',
            UNPUBLISHED_BY: 'Unpublished by',
            SAVE_PUBLISH_HISTORY: 'Save & Publish History',
            REVIEW_PROGRESS: 'Review Progress',
            LAST_PUBLISHED: 'Last Published',
            CURRENT_VERSION: 'Current Version',
            skillbuild: {
                SKILLBUILD_DESC_INST: 'The SkillBuild Critical Thinking course consists of four Skill Modules and a Capstone Assessment that awards the Critical Thinking microcredential. The four Skill Modules are: Gather and Assess Information, Question Assumptions, Identify Patterns, and Draw Conclusions. These Skill Modules may be purchased and completed independently or purchased bundled with the Capstone Assessment. The Capstone Assessment requires the learner to use all of the skills in the course together to complete a work-based challenge. Details of the Skill Modules are available below, along with options to purchase or learn more.',
                SKILLBUILD_DESC_STUD: 'The SkillBuild Critical Thinking course consists of four Skill Modules and a Capstone Assessment that awards the Critical Thinking microcredential. The four Skill Modules are: Gather and Assess Information, Question Assumptions, Identify Patterns, and Draw Conclusions. These Skill Modules may be purchased and completed independently or purchased bundled with the Capstone Assessment. The Capstone Assessment requires the learner to use all of the skills in the course together to complete a work-based challenge. Details of the Skill Modules are available below, along with options to purchase or learn more.',
                NO_ACTIVE_COURSES_STUDENT: "No currently active SkillBuild courses!",
                NO_COMPLETED_COURSES_STUDENT: "No completed SkillBuild courses!",
                NO_ACTIVE_COURSES_INSTRUCTOR: "You are not currently teaching any SkillBuild courses!",
                BADGE_ALT_DEFAULT: "SkillBuild Badge",
            },
            saves: {
                THEAD_SAVE: "Save",
                THEAD_PUBLISH: "Publish",
                THEAD_VERSION: "Version",
                THEAD_SAVE_USER: "User",
                THEAD_SAVE_DATE: "Date",
                THEAD_SAVE_MSG: "Msg.",
                THEAD_PUB_USER: "User",
                THEAD_PUB_DATE: "Date",
                THEAD_PUB_MSG: "Msg.",
                TABLE_CURRENT_VERSION: "This is the current version.",
            },
            license_types: {
                INDIVIDUAL: "Individual",
                INSTITUTION: "Institution",
            },
            actions: {
                RENAME_SC: "rename",
                REVIEW: "review",
                PREVIEW: "preview",
                COPY_SC: "duplicate course",
                MOVE_SC: "move course",
                PUBLISH_SC: "publish",
                UNPUBLISH_SC: "unpublish",
                ADD_LICENSE: "add/update license",
                UPDATE_LIC_META: "update license meta-data",
                ADD_USER_LIC: "add user license",
                SC_ANALYTICS: "short course analytics",
            },
            REPORT_CARD_ACTION_LINE: "report card shown after first action that meets its conditions",
            CONDITIONS: "Conditions",
            coach_condition_descriptions: {
                NO_CONDITIONS: "No conditions",
                firstCheck: 'True if the last attempt got the first check in the current course',
                firstStar: 'True if the last attempt got the first star in the current course',
                firstCheckEver: 'True if the last attempt got the first check in any course the user has taken',
                firstStarEver: 'True if the last attempt got the first star in any course the user has taken',
                noAdvancesNoChecks: 'True if none of the subskills advanced',
                advancedNoChecks: 'True if they advanced (remedially), but did not get any checks on the last attempt',
                oneOrMoreChecks: 'True if they got at least one check (subskill passed) from the last attempt',
            },
            available_conditions_title: "Available Conditions",
            existing_conditions_title: "Existing Conditions",
            modals: {
                RENAME_COURSE_HD: "Rename Course",
                RENAME_COURSE_LABEL: "new name",
                COPY_COURSE_HD: "Duplicate Course",
                COPY_COURSE_TITLE_LABEL: "course copy name",
                MOVE_SC_HD: "Move Course",
                ADD_LICENSE: "Add/Update License",
                publish: {
                    MODAL_HEADER: "Publish Course",
                    BLOCKED_BY_LOCK: "Cannot publish while course is locked.",
                    MSG_INPUT_LABEL: "Publish message (optional)",
                    MSG_INPUT_PHLD: "This was published because...",
                    PUB_BTN_LABEL: "Publish",
                    CHECKING_MSG: "Checking version compatibility and validating course...",
                    TT_UPDATE_INACTIVE: "Inactive course instances have not been started by any students.",
                    TT_UPDATE_ACTIVE: "Active course instances have been started by at least one student. Course instances are considered compatible if they use an older matching version of this course.",
                    VERSION_UPDATED_TO: "The version will be updated to",
                    CONFIRM_HEADING: "Confirm Publish Course",
                    CONFIRM_PROMPT: "Please confirm publishing course. The following changes will occur:",
                    CONFIRM_INACTIVE_UPDATE_TRUE: "Inactive course instances WILL be updated",
                    CONFIRM_INACTIVE_UPDATE_FALSE: "Inactive course instances WILL NOT be updated",
                    CONFIRM_ACTIVE_UPDATE_TRUE: "Compatible active course instances WILL be updated",
                    CONFIRM_ACTIVE_UPDATE_FALSE: "Active course instances WILL NOT be updated",
                    CONFIRM_BUTTON: "confirm publish",
                },
                create_instance: {
                    MODAL_HEADER: "Create Local Course Instance",
                    GROUP_DROPDOWN_LABEL: "Group",
                    GROUP_ANON_OPTION: "None (anonymous signup)",
                    INST_NAME_INPUT_LABEL: "Course Instance Name",
                    USER_NAME_TOGGLE_LABEL: "Name",
                    USER_EMAIL_TOGGLE_LABEL: "Email",
                    ACCESS_CODES_TOGGLE_LABEL: "Enable Access Codes",
                    CREATE_BUTTON_LABEL: "Create",
                    CREATING_STATUS_TEXT: "Creating Course Instance...",
                    param_options: {
                        REQUIRED: 'required',
                        OPTIONAL: 'optional',
                        HIDE: 'hide',
                    },
                },
                activity_shortcourse_metadata: {
                    TITLE: "Activity Short Course Meta Data",
                    DESC1_LABEL: "Description 1",
                    DESC2_LABEL: "Description 2",
                },
                phrase_system: {
                    MODAL_HEADER: "Coach Phrase Editor",
                    SELECT_PHRASE_SET: "Select Phrase Set",
                    ADD_PHRASE_TO_SET: "Add phrase to set",
                    DELETE_PHRASE_SET: "Delete This Phrase Set",
                    PHRASE_VARIABLE_SUFFIX: "Phrase Variable Suffix",
                    CONFIRM_DELETE_PHRASE_SET: "Are you sure you wish to delete this phrase set?",
                    PHRASES_IN_THIS_SET: "Phrases in this set",
                    EXIT_WITHOUT_SAVING: "Quit phrase editor without saving changes?",
                },
                import_course_data: {
                    MODAL_HEADER: "Import Data from another Course",
                    SELECT_OTHER_COURSE: "Select Other Course",
                    NO_OTHER_COURSES: "You have no other short courses to import data from",
                    REPLACE_ALL: "Replace All",
                    IMPORT_STICKERS: "Import Stickers",
                    IMPORT_PHRASES: "Import Phrases",
                    IMPORT_COACH_SCRIPTS: "Import Coach Scripts",
                    START_IMPORT: "Start import",
                    IMPORT_COMPLETE: "Import Complete",
                },
                add_license: {
                    MODAL_HEADER: "Add/Update Short Course License",
                    LICENSE_SELECT_LBL: "Select Existing License",
                    NEW_LICENSE_NAME: "New License",
                    TOKEN_LBL: "Token",
                    COST_LBL: "Cost",
                    SALE_COST_LBL: "Sale Cost ($0 = No Sale)",
                    LICENSE_TYPE_LBL: "License Type",
                    JOIN_COURSE_INSTANCE_HASH_LBL: "Join Course Instance Hash",
                },
                update_lic_meta: {
                    BULLET_POINTS_LBL: "Bullet Points",
                    BULLET_POINT_LBL: "Bullet Point",
                    WHAT_YOULL_LEARN_LBL: "What You'll Learn",
                    HOW_YOULL_LEARN_LBL: "How You'll Learn",
                    ASSN_COUNT_LBL: "Assignment Count",
                    TASK_COUNT_LBL: "Task Count",
                    CMPT_NAME_LBL: "Competency Name",
                    CMPT_PART_LBL: "Competency Part",
                    CMPT_TOTAL_PARTS_LBL: "Competency Total Parts",
                    CREDENTIAL_LBL: "Credential",
                    SUBCOMPETENCY_LBL: "Sub-Competency",
                    AUDIENCE_LBL: "Audience",
                    BADGE_IMAGE_LBL: "Badge Image",
                    UPLOAD_BADGE_IMAGE_LBL: "Upload Badge Image",
                },
                add_user_license: {
                    MODAL_HEADER: "Add User Short Course License",
                    LICENSE_SELECT_LBL: "Select Existing License",
                    USER_EMAIL: "User Email",
                    INSTRUCTOR_EMAIL: "Instructor Email (for initial local assignment)",
                    SELECT_DEFAULT: "Select...",
                }
            },
            chatbot: {
                PASS_BUTTON_TEXT: "Thanks! I understand now",
                FAIL_BUTTON_TEXT: "Goodbye. I give up.",
            },
        },
        short_course_instance: {
            DEFAULT_LTI_NAME: "Course",
            DEFAULT_CN_NAME: "Connect Course",
            BADGE_IMAGE_ALT: "Course Badge",
            ADD_STUDENTS: "Add Students",
            ADD_INSTRUCTORS: "Add Instructors",
            INSTRUCTORS_LABEL: "Instructors",
            JOIN_URL: "Join Url",
            INSTRUCTOR_PREVIEW: "Preview",
            COURSE_NAME_LBL: "Course:",
            COURSE_VERSION_LBL: "Course Version:",
            CREATE_DATE_LBL: "Creation Date:",
            DESC_COURSE_LBL: "Course Description:",
            DESC_INTERNAL_LBL: "Internal Description:",
            DESC_INTERNAL_TT: "This description is only visible to instructors and administrators.",
            entry: {
                NEW_STUDENT: "New student!",
                NEW_STUDENT_CNT_PROMPT: "If you don't have a code yet or would like to restart from the beginning, just press CONTINUE",
                NEW_STUDENT_NAME_PROMPT: "New Student! Please enter your name.",
                RET_STUDENTS: "Returning students",
                FNAME_INPUT_LABEL: "First Name",
                LNAME_INPUT_LABEL: "Last Name",
                FULLNAME_INPUT_LABEL: "Full Name",
                NAME_ORDER_TOGGLE_LABEL: "switch name order",
                ACCESS_CODE_INPUT_LABEL: "Please enter your access code",
                ACCESS_CODE_DISP_LABEL: "Access Code",
                ACCESS_CODE_DISP_DESC: "Save this access code. You will need to provide it to return to the course and continue your progress.",
                STATUS_LOGGING_IN: "Logging in...",
                UNAUTHORIZED: "Unauthorized",
                UNAVAILABLE: "The content for this course is no longer available.",
            },
            user_status: {
                NEW: "Not Started",
                IN_PROGRESS: "In Progress",
                COMPLETE: "Complete",
            },
            report_table: {
                TH_FIRST_NAME: "First Name",
                TH_LAST_NAME: "Last Name",
                TH_EMAIL: "Email",
                TH_STATUS: "Status",
                TH_START_TIME: "Start Time",
                TH_COMPLETE_TIME: "Complete Time",
                TH_TIME_PLAYED: "Time Played",
                TH_RESET: "Reset",
            },
            charts: {
                stats: {
                    STARTED_TITLE: "Started",
                    STARTED_DESC: "The number of students that have started the course.",
                    COMPLETED_TITLE: "Completed",
                    COMPLETE_DESC: "The number of students that have completed the course.",
                    TIME_PLAYED_TITLE: "Time Played",
                    TIME_PLAYED_DESC: "The time played distribution for all student attempts and average time per attempt.",
                },
            },
            modals: {
                add_users: {
                    MODAL_HEADER: "Add Students to Course",
                    MODAL_HEADER_INST: "Add Instructors to Course",
                    USER_EMAILS_LBL: "Student Email Addresses",
                    USER_INST_EMAILS_LBL: "Instructor Email Addresses",
                    USER_EMAILS_DESC: "Enter one or more email addresses separated by commas",
                    INPUT_EMAILS_BTN_LBL: "Validate",
                    INPUT_EMAIL_DEF_ERR: "Error parsing emails. Please check for errors and try again.",
                    INPUT_EMAIL_NONE_ERR: "No email addresses parsed from list. Please check for errors and try again.",
                    VALIDATE_EMAIL_ERROR: "Invalid email address",
                    BACK_TO_INPUT_BTN_LBL: "Back to Input (Discard)",
                    ADD_EMAILS_BTN_LBL: "Add Student(s)",
                    ADD_EMAILS_INST_BTN_LBL: "Add Instructor(s)",
                    VALID_EMAILS_LBL: "Valid Email Addresses",
                    VALID_EMAILS_DESC: "The following email addresses are valid and will be added to the course:",
                    ADD_EMAIL_LBL: "Add Student",
                    ADD_EMAIL_INST_LBL: "Add Instructor",
                    ADD_EMAIL_DESC: "Add Student via Email Address",
                    ADD_EMAIL_INST_DESC: "Add Instructor via Email Address",
                    INVALID_EMAILS_LBL: "Invalid Email Addresses",
                    INVALID_EMAILS_DESC: "The following email addresses are invalid and need to be corrected or deleted:",
                    ADD_EMAILS_TT_NO_VALID_EMAILS: "No valid email addresses to add",
                    ADD_EMAILS_TT_NO_INVALID_EMAILS: "Correct or delete invalid email addresses",
                    ADD_EMAILS_TT_HAS_OPEN_EDITS: "Finish editing email addresses before adding",
                }
            },

        },
        integration: {
            TAG_DESCRIPTION_DESC: "Optional text to help your organization understand how this tag should be used. Does NOT affect integration (LTI, etc.) configurations.",
            ESTABLISHING_LTI_CONNECTION: "Establishing LTI Connection...",
            FAILED_TO_ESTABLISH_LTI_CONNECTION: "Failed to establish LTI Connection",
            GENERAL_LTI_LAUNCH_ERROR: "There was an error launching this resource. Please try again later.",
            cookie_troubleshooting: {
                SES_COOKIE_NP: "Valid session cookie is not present.",
                COOKIE_TS_DESC: "Your browser may be blocking third-party cookies. Please follow the instructions below to enable third-party cookies for this site.",
                BROWSER: "Browser",
                BROWSER_SAFARI: "Safari",
                BROWSER_CHROME: "Chrome",
                safari: {
                    SETTINGS_DESC: "If you're using Safari, please ensure that your settings match the following:",
                    ver_15_plus: { 
                        VERSION: "Safari 15.x+",
                        GUIDANCE_LI_1: "macOS: Safari > Settings > Privacy > Prevent cross-site tracking: Unchecked",
                        IMG_1_ALT: "MacOS Safari 15.x+ privacy preferences",
                        GUIDANCE_LI_2: "iOS/iPadOS: Settings > Apps > Safari > Privacy & Security > Prevent Cross-Site Tracking: Unchecked",
                        IMG_2_ALT: "iOS Safari 15.x+ privacy preferences",
                        
                    },
                    ver_13_14: { 
                        VERSION: "Safari 13.x or Safari 14.x",
                        GUIDANCE_LI_1: "Currently, a workaround for Safari 13.x/14.x is not available. Google Chrome or Mozilla Firefox will still work as intended.",
                    },
                    ver_11_12: { 
                        VERSION: "Safari 11.x or 12.x",
                        GUIDANCE_LI_1: "Preferences > Privacy > Prevent cross-site tracking: Unchecked",
                        IMG_1_ALT: "Safari 12.x privacy preferences",
                    },
                    ver_10: { 
                        VERSION: "Safari 10.x",
                        GUIDANCE_LI_1: "Preferences > Privacy > Cookies and website data: Always allow",
                        IMG_1_ALT: "Safari 10.x privacy preferences",
                    },
                },
                chrome: {
                    SETTINGS_DESC: "If you're using Chrome, please ensure that your settings match the following:",
                    ipados_18: {
                        VERSION: "Chrome for iPadOS 18.x",
                        GUIDANCE_LI_1: 'Chrome and other third-party browsers running on iPadOS 18.x appear to have an issue where the "Allow Cross-Website Tracking" setting is ignored. Please use Safari on iPadOS',
                    },
                    ver_84_plus: {
                        VERSION: "Chrome 84.x or more recent",
                        GUIDANCE_LI_1: "In Settings, ensure that the following is selected: Privacy and Security > Third-party cookies > Allow third-party cookies",
                        IMG_1_ALT: "Chrome 84.x+ privacy settings",
                    }

                },
            },
        },
        dashboard: {
            INSTRUCTOR_ASSIGNMENTS: "Assignments I'm Teaching",
            STUDENT_ASSIGNMENTS: "Assignments I'm Taking",
            INSTRUCTOR_COURSE_INSTS: "Courses I'm Teaching",
            STUDENT_COURSE_INSTS: "Courses I'm Taking",
            GROUPS: "Groups",
            EXPLORE: "Explore",
            EXPLORE_COURSES: "Explore Courses",
            SKILLBUILD_STORE: "SkillBuild Store",
            AUTHOR: "Author",
            HELP: "Help",
            COURSES: "Courses",
            ASSIGNMENTS: "Assignments",
            HOME: "Home",
            STUDENT_HOME: "Student Home",
            // INSTRUCTOR_HOME: "Instructor Home",
            WELCOME_MESSAGE: "Welcome back,",
            LAST_LOGIN: "Last Login:",
            YOUR_COURSES: "Your Courses",
            ACTIVE_COURSES: "Active Courses",
            YOUR_PROGRESS: "Your Progress",
            HISTORY: "History",
            COMPLETED_COURSES: "Completed Courses",
            SUB_SKILLS: "Sub-Skills",
            HOURS_SPENT: "Hours Spent",
            AVERAGE_SCORE: "Average Score",
            TOTAL_STARS: "Total Stars",
            JOBIFICATION_CARDS: "Jobification Cards",
            CHANNELS_HAMBURGER_TITLE: "Channels",
            WELCOME_PROMPT: 'Welcome to Muzzy Lane Author! There are example activities for you to try out in the "Sample Activities" organization that you can access from the link on the left side of the page. You can also join our Discord community using this link. And if you’d like trial access to the AI features, please reach out to us here!',
            DISCORD_LINK: "Discord link",
            REACH_OUT_LINK: "Reach out to us link",
            NEW_PROJ_PROMPT: "Add a project to the channel.",
            SELECT_CHANNEL: "Select a channel or organization",
            NO_CHANNELS: "No available channels or organizations",
            help: {
                MENU_TITLE: "help",
                KNOWLEDGE_BASE: "Knowledge Base",
                CUSTOMER_PORTAL: "Customer Portal",
                SUBMIT_TICKET: "Submit a Ticket",
                DISCORD: "Muzzy Lane Discord",
                TERMS: "Terms and Conditions",
                PRIVACY: "Privacy Policy",
            },
            account: {
                MENU_TITLE: "account",
                STUDENT_ROLE: "Student Dashboard",
                INSTRUCTOR_ROLE: "Dashboard",
                ADMIN: "Admin",
                SETTINGS: "Settings",
                SIGN_OUT: "Sign Out",
            },
        },
        voice_options: {
            title: "Voice Options",
            sample_text_label: 'Sample Text',
            sample_text: "Hello! How are you today?",
            Engine: 'Engine',
            Voice: 'Voice',
            SelectVoice: 'Select Voice',
            NoVoice: 'No Voice',
            VOLUME: 'Volume',
            VOICE_ENABLED: 'Voice Enabled',
            NPC_VOICE_ENABLED: 'Enable voice for non player characters',
        },
        course_purchase_page: {
            COURSE_SUMMARY: "Course Summary",
            COURSE_CARD_IMAGE: "Course Card Image",
            COURSE_PURCHASE_IMAGE: "Course Purchase Image",
            WHAT_YOULL_LEARN: "What You'll Learn",
            HOW_YOULL_LEARN: "How You'll Learn",
            WHAT_YOULL_EARN: "What You'll Earn",
            WHAT_THIS_COURSE_INCLUDES: "What This Course Includes",
            BADGE_SUB_DESC_DEFAULT: "Industry-validated credential",
            ASSIGNMENTS: "assignments",
            TASKS: "tasks",
            CREDENTIAL: "credential",
            WHO_IS_THIS_COURSE_FOR: "Who Is This Course For",
            BUY_THIS_COURSE: "Buy This Course",
            SHARE_THIS_COURSE: "Share This Course",
            YOU_OWN_COURSE: "You Own This Course",
            PURCHASE_SUCCESS_MSG: "Course purchased!",
            GIFT: "Gift",
            CALL_US: "Contact Us",
        },
        act_meta_tags: {
            ACTS_W_ATTACHED: 'Activities with Tag Attached',
            ACTIVITY_META_TAG: 'Activity Meta Tag',
            ADD_TAG_ACT: "Add tag to activity",
            CATEGORY: "Category",
            CATEGORY_ALLOW_MULT_DESC: "Multiple tags from this category may be attached to an activity",
            CATEGORY_DISALLOW_MULT_DESC: "Only one tag from this category may be attached to an activity",
            CATEGORY_FREE_FORM_TYPE_DESC: "Activity/Project-level users can attach new tags or tags from an Organization-controlled list",
            CATEGORY_ORG_CONTROLLED_TYPE_DESC: "Activity/Project-level users can only attach existing tags from an Organization-controlled list",
            DATE_ATTACHED: 'Date Attached',
            DELETE_TAG: 'Delete Tag',
            DISPLAY_ORDER: 'Display Order',
            NEW_TAG: "New Tag",
            REMOVE_TAG_ACT: "Remove tag from activity",
            TAG_DISPLAY_ORDER_DESC: "Certain Activity Meta Data Tag categories require a user-defined order. Tags in this category will use this order when shown in instructor activity-chooser filters.",
            TAG_FILTER_NONE: "No tags for filter",
            TAG_LIST_NONE: "No tags available",
            TAG_NAME: "Tag Name",
        },
        act_meta_types: {
            ACTIVITY_TYPE: "Activity Type",
            TYPE_NAME: "Type Name",
            ATTACHED_ACTS: "Attached Activities",
            DELETE_TYPE: "Delete Type",
            TYPE_DISPLAY_NAME: "Type Display Name",
            CATEGORY_DISALLOW_MULT_DESC: "Only one type from this category may be attached to an activity",
            CATEGORY_ORG_CONTROLLED_TYPE_DESC: "Activity/Project-level users can only attach existing types from an Organization-controlled list",
            ACTS_W_ATTACHED: 'Activities with Type Attached',
            TYPE_FILTER_NONE: "No types for filter",
            TYPE_LIST_NONE: "No types available",
            ADD_TYPE_ACT: "Add type to activity",
            REMOVE_TYPE_ACT: "Remove type from activity",
        },
        project: {
            PROJECT: 'Project',
            PROJECT_DUPLICATE_NAME_ERR: "A project with this name already exists.",
            NO_ACTIVITIES: "No activities here.",
            NO_SHORT_COURSES: "No short courses here.",
            TRY_ADDING_ACT: "Try adding an activity!",
            TRY_ADDING_SC: "Try adding a short course!",
            NO_ACTIVITIES_FOR_FILTER: "No activities found for filter.",
            NO_SHORT_COURSES_FOR_FILTER: "No short courses found for filter.",
            FILTER_BY_NAME: "Filter By Name",
            FILTER_BY_TAG: "Filter By Tag",
            PROJ_DESC: "Project Description",
            PROJ_DESC_PROMPT: "Write a description of your project here",
            collaborators: {
                EMAIL_MISS_ERR: "Please enter an email address",
                ROLE_MISS_ERR: "Please select a project role",
                ADD_NEW_COLLAB: "Add New Collaborator",
                PENDING_STATUS_INDIC: "[Pending]",
                SEARCH_TITLE_PRE: "Organization members not already on this project",
                SEARCH_TITLE_POST: "Matching organization members not already on this project",
                SEARCH_NO_MEMBERS: "No organization members",
                SEARCH_NO_RESULT: "No organization members to add",
                SEARCH_MATCHES_ITEM_TERM: "matches",
                LAST_ACTIVE: "Last active",
                PROJECT_COLLAB_ROLES: "Project Collaborator Roles",
                REMOVE_USER: "Remove user from project",
                ADD_NEW: "Add new project role",
                remove_modal: {
                    TITLE: "Remove collaborator",
                }
            },
            actions: {
                NEW_ACT: "new activity",
                NEW_SC: "new short course",
                STACK_IMPORT_ACT: "stack import",
                STACK_IMPORT_COURSE: "stack import course",
                STACK_IMPORT_PROJECT: "stack import project",
                SORT_ALPHA: "sort alphabetically",
                SORT_TEMPLATE: "sort by template",
                SORT_CREATED: "sort by create date",
                SORT_MODIFIED: "sort by last update date",
                EDIT_PC: "edit project collaborators",
                VIEW_PC: "view project collaborators",
                RENAME_P: "rename project",
                COPY_P: "duplicate project",
                TRANSFER_P: "move project",
                DELETE_P: "delete project",
                MANAGE_P_ITAGS: "manage integration tags",
                ANALYTICS: "project analytics",
            },
            modals: {
                NEW_SC_HEADER: "Create Short Course",
                NEW_SC_INPUT_LABEL: "title",
                NEW_SC_INPUT_DEFAULT: "New Short Course",
                NEW_SC_BUTTON_TEXT: "create",
                RENAME_HEADER: "Rename Project",
                RENAME_INPUT_LABEL: "new name",
                RENAME_BUTTON_TEXT: "confirm",
                DELETE_CONFIRM_PHRASE: "delete",
                DELETE_CANCEL_BUTTON_TEXT: "cancel",
                DELETE_WARNING_ACT: "Are you sure you would like to delete this project? This will delete all project activities. This cannot be undone.",
                DELETE_WARNING_SC: "Are you sure you would like to delete this project? This will delete all project short courses. This cannot be undone.",
            }
        },
        organization: {
            MEMBERS: "Members",
            MATCHING_MEMBERS: "Matching Members",
            ROLE: "Role",
            NEW_MEMBER: "New Member",
            REMOVE_FROM_ORG: "Remove From Organization",
            PENDING_MEMBER: "Pending Member",
            PENDING_MEMBER_TT: "Pending members have been sent a Muzzy Lane Author confirmation email but have not yet completed account registration.",
            USER_PORTRAIT_ALT: "User Portrait",
            logo: {
                ALT: "Organization Logo Image",
                BTN_TEXT: "Upload Logo Image",
            },
            remove_user_modal: {
                TITLE: "Remove User",
                TEXT: "Are you sure you want to remove this user from the organization?",
                CONFIRM_BTN_LBL: "Remove",
            }
        },
        error: {
            GEN_OBSCURED_ERR: "Oops, something went wrong. We're looking into it!",
            COPY_CLIPBOARD_ERR: "Copying to clipboard failed",
            UNKNOWN_ERROR: "Unknown Error",
            INTERNAL_GENERAL_NOTIF: "Internal server error. Administrators have been notified.",
            NOT_FOUND_PROJECT: "Project not found",
            NOT_FOUND_ACTIVITY: "Activity not found",
        },
        assignment: {
            YOU: "You",
            CLASS: "Class",
            CLASS_RESULTS: "Class Results",
            YOUR_RESULTS: "Your Results",
            OPT_OUT: "Did Not Share",
            NO_ACT_ASSIGNED: "No Activity Assigned",
            SCORE_TYPE: "Score Type",
            NUM_ATTEMPTS: "Number of Attempts",
            CONNECT_CONT: "Controlled by Connect",
            UNLIMITED: "Unlimited",
            NOT_AVAIL_FOR_ASSN_TYPE: "Not available for assignment type",
            TURN_TYPE: "Turn Type",
            CURRENT_TURN: "Current Turn",
            END_TURN: "End Turn",
            TURN_IS_ENDING: "Turn is ending...",
            END_TURN_BEFORE_START_ERROR: "Cannot end turn when assignment waiting to begin",
            END_TURN_PAST_END_ERROR: "Cannot end turn when assignment is past End Date",
            END_TURN_STATUS_ERROR: "Last turn ending encountered an error. Administrators have been notified.",
            TURNS_COMPLETED: "All turns completed!",
            TURN_ENDED_NOW_ON_TURN: "Turn ended. You are now on turn",
            OF: "of",
            CONTACT_INSTRUCTOR_TO_ASSIGN: "Please contact your instructor immediately to be assigned to a game",
            RESET: "Reset",
            INSTRUCTOR: "Instructor",
            STUDENT: "Student",
            STUD_NAME_NOT_PROVIDED: "Not Provided",
            SHOW_ATT_ARIA_LBL: "Show Attempts",
            PROFILE_BTN_LBL: "profile",
            LOGOUT_BTN_LBL: "logout",
            RESET_CONFIRM_GENERAL: "Reset all pending changes?",
            POLICY_COMPLETED_WARNING: "Cannot edit activity policies once assignment has been completed.",
            POLICY_MULTI_ACTIVE_WARNING: "Only Multiplayer Configuration policy can be edited once assignment has been started by students.",
            POLICY_MULTI_CHILD_WARNING: "Only Multiplayer Configuration policy can be edited by secondary instructor for a shared assignment.",
            POLICY_IS_ACTIVE_WARNING: "Cannot edit activity policies once assignment has been started by students.",
            POLICY_IS_CHILD_WARNING: "Secondary instructor cannot edit activity policies for shared assignment.",
            REPORT_PREV: "Previous",
            CREATE_EDIT_CONTINUE: "Continue",
            CREATE_EDIT_WAIT: "Please wait...",
            CREATE_EDIT_PREV_CHOOSE_ACT: "Previous: Choose Activity",
            POLICIES_TITLE: "Modify Policies",
            NO_ATTEMPTS: "No Attempts",
            OPEN_ENROLLMENT: "Open Enrollment",
            OE_ENABLE: "Enable Open Enrollment",
            OE_STUDENTS_PER_GAME: "Number of Students per Game",
            OE_STUDENTS_PER_TEAM: "Number of Students per Team",
            OE_TEAMS_PER_GAME: "Number of Teams per Game",
            OE_DESCRIPTION: "If Open Enrollment is enabled all students in this Connect section prior to the Start Date/Time of the assignment will automatically be added to the assignment. Students joining the Connect section after the Start Date/Time will not be added to the assignment.",
            ORDER_LOCK_LABEL: "Lock Activity Order",
            ORDER_LOCK_DESC: "If enabled, students will be required to complete activities in the order specified by the instructor.",
            ORDER_UP_LABEL: "Move Up",
            ORDER_DOWN_LABEL: "Move Down",
            MULTI_ACT_ATT_LABEL: "# of Retries",
            MULTI_ACT_WEIGHT_LABEL: "Weight",
            MULTI_ACT_WEIGHT_SUM_LABEL: "Total Weights",
            MULTI_ACT_DISCARD_WEIGHT_CHANGE: "Discard Weight Changes",
            MULTI_ACT_WEIGHT_DISCARD_STATUS: "Weight values have been reset to their default values.",
            ACT_UNPUBLISHED_NOTICE: "The activity for this assignment is no longer available. Please contact your instructor to receive a replacement activity.",
            ACT_MULTI_UNPUBLISHED_NOTICE: "At least one activity for this assignment is no longer available. Please contact your instructor to receive a replacement assignment.",
            ACT_UNAVAIL: "The activity for this assignment is no longer available.",
            ACT_UNAVAIL_SELECT_NEW: "The activity for this assignment is no longer available. Please choose another activity.",
            ACT_UNAVAIL_SELECT_NEW_MULTI: "At least one activity for this assignment is no longer available. Please choose another activity or continue without changes to confirm removal of unavailable activity.",
            ACT_UNAVAIL_CREATE_NEW: "The activity for this assignment is no longer available. Please create a replacement assignment.",
            CLOSE_ACTIVITY: "Close Activity",
            CN_ASSN_NAME_DEFAULT: "Connect Assignment",
            CN_MULTI_ASSN_NAME_DEFAULT: "Multi-ABA Assignment",
            WEIGHT_DISTRIB: "Assignment Score Weight Distribution",
            TT_WEIGHT_DISTRIB: "The distribution of the weighted objectives used to calculate the Overall Score of the activity.",
            ACT_SEL_DISABLED_UNSUPPORTED_ALL: "The selected activity is not supported for use in Multi-ABA assignments",
            ACT_SEL_DISABLED_UNSUPPORTED_TEMPLATE: "This activity type is not supported for use in Multi-ABA assignments",
            NO_MULTI_ACT_TT_DESC: "Non-Multi-ABA description",
            NO_MULTI_ACT_TT: "Note: This activity type is not supported for use in Multi-ABA assignments",
            MULTI_ACT_LOCK_PLAY_DISABLED_NOTICE: "Activity order is locked. You must complete the previous activity before you can play this activity.",
            UNSPECIFIED_ACT_TEMPLATE: "Unspecified Activity Template",
            ASSN_STATUS: "Status",
            NAME_NP: "Not Provided",
            NAME_NP_ID_LABEL: "ID:",
            TABLE_HEADER_BUTTONS_SORT: "column headers with buttons are sortable",
            report: {
                ATTEMPT_LBL: "Attempt",
                TRY_LBL: "Try",
                SCORE_LBL: "Score",
                TIME_PLAYED_LBL: "Time Played",
                HISTORY_LBL: "History",
                REVIEW_LBL: "Review",
                NO_TRIES_FOR_ACT: "No tries for activity",
                NO_RECORDS_FOR_ATT_NUM: "No records for attempt number",
                ACTIVE_FILTER: "Active Filter",
                REMOVE_FILTER: "Remove Filter",
                STUDENT_ID_FILTER: "ID",
                NO_STUDENTS_FOR_FILTER: "No students found for filter",
                TABLE_TITLE_RESULTS: "Results",
                TABLE_TITLE_STUDENTS: "Students",
                STUDENT_ATTEMPT_TABLE: "Student attempt table",
                ANALYTICS_CATEGORY_DESC: "Analytics Category: This metric is related to analytics and indirectly contributes to the Score.",
                ANALYTICS_CATEGORY_INFO_LBL: "More info about ",
            },
            exports: {
                DEFAULT_EXPORT_BTN_TITLE: "Export",
                EXPORT_UPGRADE_BTN_TITLE: "Upgrade to access this feature",
                EXPORT_NO_SCORES_BTN_TITLE: "No scores to export",
                EXPORT_NO_DETAILS_BTN_TITLE: "No details to export",
                EXPORT_SCORES_BTN_LABEL: "Export scores",
                EXPORT_DETAILS_BTN_LABEL: "Export details",
                STUDENT_ATTEMPT_TABLE: "Student Attempt Table",
            },
            status: {
                NEW: "New",
                SETTING_UP: "Setting Up",
                CREATING: "Creating",
                PENDING_READY: "Waiting to Start",
                READY: "Active",
                INTERVENTION_NEEDED: "Intervention Needed",
                COMPLETE: "Complete",
                ERROR: "Error",
            },
            turn_type: {
                MANUAL: "Manual",
                CONTROLLED: "Instructor Controlled",
                SCHEDULED: "Scheduled",
            },
            turn_date: {
                TIME: "Time of day",
                DAYS: "Days of week",
                TURN_ENDING_TIME_DAYS: "Turn Ending Time and Days",
                TURN_NUMBER: "Turn Number",
                TURN_NO_CHANGE: "No change",
                TURN_REMOVED: "Turn removed",
                ASSN_END_DATE_NOTICE: "Assignment End Date",
                END_DATE: "End Date",
                PREVIEW_END_DATE: "Preview End Date",
                SHOW_TURN_DATES: "Show Turn Dates",
            },
            cookie_fix: {
                CF_APPLY: "Apply Cookie Fix",
                SA_UNABLE_TO_GRANT: "Unable to grant storage access",
                CF_SUCCESS: "Cookie fix set! You may close this page.",
                CF_UNABLE: "Unable to set cookie fix.",
                CF_ATTEMPTING: "Attempting to set cookie fix.",
            },
            user_att_history_modal: {
                MODAL_TITLE: "Attempt History",
                NO_ATTEMPT_HISTORY: "No records",
                DATE: "Date",
                STATUS: "Status",
                ERROR_MESSAGE: "Error Message",
            },
            policy: {
                turn_events: {
                    ADD_REMOVE: "Add/Remove",
                    TURN_NUMBER: "Turn number",
                    EVT_DESC: "Event description",
                    ACTIVE_TURN_EVENTS: "Active Turn Events",
                    DELETE_EVT_ARIA_PREFIX: "Delete event for turn",
                },
            },
            connect: {
                ACT_SELECT_HEADING: "Application-Based Activities (ABA)",
                ACT_SELECT_HEADING_DESC: 'Choose one or more ABAs to add to the assignment by clicking the checkbox in the Select checkbox column (NOTE: Not all ABA types support multi-ABA assignments). To learn more about an ABA, preview the student experience, or see a summary of the learning objectives and questions, click the activity details button in the Expand/Collapse activity column. Once you have selected one or more ABAs to be included in the assignment click the “Assign” button to proceed to setting policy options.',
                ABA_IMAGE_DEF_ALT: "ABA Activity",
                ACT_SELECT_RETURN: "Previous: Section Home",
                ACT_FILTER_RESULTS: "Filter Results",
                ACT_SELECT_CHECKBOX: "Activity Select Checkbox",
                ACT_DETAIL_EXPAND_COLLAPSE: "Activity Detail Expand/Collapse",
                ATT_IN_PROGRESS: "Attempt In Progress",
                MULTI_ATT_IN_PROGRESS: "Assignment Attempt In Progress",
                PREVIEW_ACT: "Student Preview",
                INST_PREVIEW_ACT: "Activity Details",
                ANALYTICS_ACT: "View Analytics",
                SUBMIT_BTN_LBL: "Submit",
                RET_TO_CONNECT_BTN_LBL: "Previous",
                TRY_LBL: "Try",
                START_TRY_BTN_LABEL: "Start Try",
                RESUME_TRY_BTN_LABEL: "Resume Try",
                REVIEW_TRY_BTN_LABEL: "Review Try",
                ERROR_TRY_BTN_LABEL: "Error in Try",
                OVERALL_SCR: "Overall Score",
                STUD_REPORT_TITLE: "Attempt Report",
                INST_REPORT_TITLE: "Assignment Report",
                STUD_REPORT_COOKIE_ERR: "Unable to view report. Valid session cookie is not present.",
                STUD_REPORT_HD: "Your Results",
                INST_REPORT_HD: "Assignment Details",
                INST_CHART_HD: "Assignment Summary",
                INST_RANGE_CHART_HD: "Class Results",
                SCORE_SUBMISSION_CONFIRM_TITLE: "Confirm Score Submission",
                SCORE_SUBMISSION_ENSURE_ALL: "Prior to submission, please ensure that you have completed a try for each available activity.",
                SCORE_SUBMISSION_NOTICE: "The Overall Score will now be submitted for this assignment. No In-Progress tries can be resumed nor can any new tries be started. This cannot be undone.",
                MULTI_ACT_INST_PREV_NOTICE: "This is a preview of the assignment as it will appear to students. Activity tries will not be recorded and activities may be started in any order, regardless of assignment policies.",
                OF_OVERALL_ATT_SCR: "of Overall Attempt Score",
                MULTI_ABA_SCORING_EXP_LBL: "Scoring Explanation",
                MULTI_ABA_SCORING_EXP: "Multi-ABA assignment attempts are scored using the highest scoring try for each activity. The highest scoring try is first multiplied by that activity's weight. Each of these weighted try scores are then summed to get the overall attempt score.",
                COMP_SCR_CONTROLS_LABEL: "Scoring:",
                COMP_SCR_ACC_LABEL: "Accuracy",
                COMP_SCR_COMP_LABEL: "Completion",
                COMP_SCR_POLICY_DESC: "Accuracy (default): Student grade will be based on performance in the ABA. Completion: Student will be awarded 100% grade upon completion of the ABA.",
                MKT_CUSTOM1_EXP_ASSN_INCOMPLETE: "Marketing Custom 1 export requires that assignment be complete",
                BUGGED_STUDENT_DISP_NAME: "null",
                exports: {
                    SCORE_CSV_LBL: "Export Score CSV",
                    DETAILS_CSV_LBL: "Export Details CSV",
                    MKT_CUSTOM_1_LBL: "Export NAIT Custom Report 1",
                },
                policy: {
                    TUTORIAL: "Tutorial",
                    PART_GOAL_SCR: "Partial Goal Scoring",
                    ASSN_WEIGHTS: "Assignment Weights",
                    ASSN_WEIGHTS_DESC: "(Optional) Update the percentage each category contributes to the final score.",
                    ASSN_TURN_LEN: "Assignment Turn Length",
                    ASSN_TURN_LEN_DESC: "Configure the number of turns in each attempt.",
                    ASSN_TURN_TYPE: "Assignment Turn Type",
                    ASSN_TURN_TYPE_DESC: "Configure the way in which turns are ended.",
                    ASSN_TURN_EVENTS: "Turn Events",
                    ASSN_TURN_EVENTS_DESC: "(Optional) Add custom events that take effect on a given turn.",
                    OPT_CONTENT: "Optional Content",
                    OPT_CONTENT_DESC: "Enable optional content for the activity.",
                    ASSN_DATES: "Assignment Dates",
                    ASSN_DATES_DESC: "Set assignment date(s).",
                    multiplayer: {
                        MULTI_CONF: "Multiplayer Configuration",
                        MULTI_CONF_DESC: "Configure how students are added to games.",
                        MULTI_CONF_TEAM: "Multiplayer Configuration",
                        MULTI_CONF_TEAM_ALT: "Multiplayer Team Configuration",
                        MULTI_CONF_TEAM_DESC: "Configure how students are added to teams and how teams are added to games.",
                        AUTO_GAME_CONF: "Automatic Game Configuration",
                        AUTO_GAME_CONF_DESC: "Automatic game configuration options. These options will override manual game configuration options.",
                        AUTO_TEAM_GAME_CONF: "Automatic Team & Game Configuration",
                        AUTO_TEAM_GAME_CONF_DESC: "Automatic team and game configuration options. These options will override manual team and game configuration options.",
                        MAN_TEAM_GAME_CONF: "Manual Team & Game Configuration",
                        MAN_TEAM_CONF: "Manual Team Configuration",
                        MAN_TEAM_CONF_DESC: "Create teams and add students to teams.",
                        MAN_GAME_CONF: "Manual Game Configuration",
                        MAN_GAME_CONF_DESC: "Create games and add teams to games.",
                        DEF_TEAM_PREFIX: "Team",
                        DEF_GAME_PREFIX: "Game",
                        RESET_ALL_BUTTON: "Reset All",
                        RESET_ALL_BUTTON_ARIA_LBL: "Reset All – Manual Team & Game Configuration",
                        AUTO_ASSN_MODAL_BUTTON: "Auto-Assign",
                        AUTO_ASSN_MODAL_BUTTON_ARIA_LBL: "Automatically assign students to teams and teams to games",
                        CONFIG_RESET_STATUS: "Configuration has been reset",
                        GAME_CONFIG_RESET_STATUS: "Game configuration has been reset",
                        TEAM_CONFIG_RESET_STATUS: "Team configuration has been reset",
                        REFRESH_SECT_STUDENTS: "Refresh Section Students",
                        REFRESHING_SECT_STUDENTS: "Refreshing...",
                        user_team_dnd: {
                            RESET_CONFIRM: "Reset all pending team changes?",
                            RESET_LABEL_TEXT: "Reset Manual Team Configuration",
                            ADD_BTN_TEXT: "Add Team",
                            ADD_BTN_LBL: "Add Team for Manual Team Configuration",
                            POOL_TITLE: "Unassigned Students",
                            EMPTY_POOL_TEXT: "No students",
                            EMPTY_DROPPABLE_TEXT: "Drop student(s) to assign",
                            EMPTY_DROPPABLE_TEXT_RO: "No student(s) assigned",
                            BASE_GROUPING_NAME: "Team",
                            BASE_DRAGGABLE_NAME: "Student",
                            EMPTY_GROUPINGS_TEXT: "No teams.",
                        },
                        team_game_dnd: {
                            RESET_CONFIRM: "",
                            RESET_LABEL_TEXT: "",
                            ADD_BTN_TEXT: "",
                            ADD_BTN_LBL: "",
                            POOL_TITLE: "",
                            EMPTY_POOL_TEXT: "",
                            EMPTY_DROPPABLE_TEXT: "",
                            EMPTY_DROPPABLE_TEXT_RO: "",
                            BASE_GROUPING_NAME: "",
                            BASE_DRAGGABLE_NAME: "",
                            EMPTY_GROUPINGS_TEXT: "",
                        },
                        conf_reset_modal: {
                            MODAL_TITLE: "Confirm Reset",
                            CONFIRM_TEXT: "Reset all pending team/game changes?"
                        },
                        auto_assn_modal: {
                            MODAL_TITLE: "Auto-assign Teams/Games",
                            S_PER_T: "Students Per Team",
                            S_RANDOMIZE: "Randomize Students",
                            T_PER_G: "Teams Per Game",
                            BTN_ASSN: "assign",
                        }
                    }
                },
            },
            vantage: {
                SAGE_VANTAGE: "Sage Vantage",
                MISSING_SESSION_COOKIE: "Unable to launch assignment. Valid session cookie is not present.",
                ASSN_DETAILS: "Assignment Details",
                ACTIVITY: "Activity",
                BACK_TO_VANTAGE_LBL: "Back",
                ERROR_MISSING_CUR_ATT: "Current attempt number not provided",
                ERROR_MISSING_CUR_ATT_STACK: "Please include 'custom_current_attempt' parameter in LTI launch package. Ex: \"custom_current_attempt\": 1",
                ERROR_SENDING: "Error sending attempt score to Vantage. Try resending score below.",
                ERROR_SENDING_ACTIVE: "Error sending latest attempt score to Vantage. Try resending score below.",
                ERROR_UNSUPPORTED_ASSN_TYPE: "Unsupported assignment type",
                ERR_ASSN_STATUS: "Assignment has encountered an error",
                ASSN_SETUP: "Assignment Setup",
                INST_ACT_PREVIEW: "Student View",
                QLA_VIEW_BTN_LABEL: "Question-level Analytics",
                ATT_ERR_ADMIN_NOTIF: "Error in Attempt - administrators have been notified",
                ATT_ERR_NOT_FOUND: "Attempt not found for student",
                play_button: {
                    ASSN_SET_UP: "Assignment is being set up",
                    ASSN_AWAITING_START: "Assignment is awaiting start date",
                    ASSN_COMPLETE: 'Assignment is complete',
                    ERROR_IN_ATT: "Error in Attempt",
                    ATT_COMPLETED: "Attempt complete!",
                    ATT_ABANDONED: "Attempt abandoned",
                    ERROR_ADMIN_NOTIFIED: "Administrators have been notified.",
                    BTN_SUB_ATT: "Attempt",
                    BTN_SUB_SCR: "Score",
                    PLAY_ATTEMPT: "Play Attempt",
                    RESUME_ATTEMPT: "Resume Attempt",
                    REPORT_ONLY: "Report View",
                },
                review_button: {
                    ASSN_SET_UP: "Assignment is being set up",
                    ASSN_AWAITING_START: "Assignment is awaiting start date",
                    REVIEW_ATTEMPT: "Review Attempt",
                    ATT_NOT_COMPLETE: "Attempt not complete",
                    ATT_FORCE_COMPLETED: "Attempt force completed",
                    BTN_SUB_ATT: "Attempt",
                    ERROR_IN_ATT: "Error in Attempt",
                    ATT_ABANDONED: "Attempt abandoned",
                },
                resend: {
                    SCORE_LABEL: "Score",
                    BTN_LABEL: "Resend Score to Vantage",
                    RESEND_LATEST_BTN_LABEL: "Resend latest score",
                }
            }, 
            mzl: {
                NEW_STUDENT_ENTER_YOUR_NAME: "New Learner! Please enter your name.",
                NEW_STUDENT_LABEL: "New learner!",
                NEW_STUDENT_INSTRUCTIONS: "If you don't have a code yet or would like to restart from the beginning, just press CONTINUE",
                RETURNING_STUDENT_LABEL: "Returning learners:",
                RETURNING_STUDENT_INSTRUCTIONS: "Please enter your access code",
                EMAIL_ADDRESS_OPTION_LABEL: 'Email Address: ',
                OPTION_TEXT: { // associated with EMAIL_OPTIONS or NAME_OPTIONS in constants/strings
                    optional: 'optional',
                    required: 'required',
                    hide: 'hide'
                },
                AUTHORIZING: "Authorizing...",
                ACCESS_CODE_PROMPT_PREFIX: "Enter your ",
                SET_UP_YOUR_LEARNER_PROFILE: "Set up your learner profile",
            },
            analytics: {
                ASSN_ANALYTICS: "Assignment Analytics",
                ASSN_ANALYTICS_EMPTY_DESC: "This page provides an assignment summary, weighted objectives used to calculate grades, and shows all questions students may encounter.",
                ASSN_ANALYTICS_EMPTY_STUDENT_PREVIEW_MSG: "To play the activity as a student would, return to the previous screen and select Student Preview",
                ASSN_ANALYTICS_EMPTY_TABLE_MSG: "Following are all the questions that students may encounter in this activity. Expand a question to see all possible responses and their scoring impact. If there are point values under a Learning Objective then this question will impact performance on that objective. The response with the highest point value for an objective awards full credit, lower point values award partial credit, and a blank awards no credit.",
                ASSN_ANALYTICS_DESC: "See below for overall activity statistics, learning objectives, and a list of questions students could see based on path taken.",
                ANALYTICS_NA_FOR_TEMPLATE: "Assignment analytics are not available for this activity type",
                ANALYTICS_NA_FOR_UNPUBLISHED: "Assignment analytics are not available for this activity",
                LO_WEIGHTS: "Learning Objective Weights",
            }
        },
        score_type: {
            HIGHEST: 'Highest',
            LATEST: 'Latest',
            AVG: 'Average',
        },
        export: {
            DOWNLOAD_CSV_FILE: "Download CSV file",
            REPORT_GEN_DATE: "Report Generation Date",
            mkt_custom_1: {
                SHEET_NAME: "Grades",
                HDR_FIRST_NAME: "First Name",
                HDR_SURNAME: "Surname",
                HDR_GAME_NAME: "Game",
                HDR_COMPANY_NAME: "Company",
                HDR_TURN_X: "Turn",
                HDR_TOTAL: "Total Turns %",
                HDR_SCORE: "Score",
                HDR_RAW_POSTFIX: "(Raw)",
                HDR_BONUS: "Bonus",
                HDR_FINAL_MARK: "Final Mark",
            },
        },
        tag: {
            TAG_NAME: "Tag Name",
            DESCRIPTION: "Description",
            ALSO_ACTIVE_PROJECT: "This tag is also active at the project level.",
        },
        navigation: {
            GO_BACK: "navigate back",
        },
        activity_comment: {
            status: {
                OPEN: "Open",
                RESOLVED: "Closed",
                UNKNOWN: "Unknown", // error case
            },
        },
        date: {
            NOT_AVAILABLE: "No date available",
        },
        maintenance: {
            DEFAULT_MESSAGE: "This site is undergoing maintenance. We apologize for any inconvenience.",
        },
        course: {
            COURSE_DASHBOARD: "Course Dashboard",
            UNNAMED_COURSE: "Unnamed Course",
            COURSE_CREATED: "Course Created",
            LAST_ACCESSED: "Last Accessed",
            STUDENTS_ENROLLED: "Students Enrolled",
            NO_ASSIGNMENTS: "Number of Assignments",
            ASSN_DETAILS: "Assignment Details",
            ASSN_ACT_PREVIEW: "Preview",
            ASSN_EXPORT_DETAILS: "Export Details",
            ASSN_EXPORT_SCORES: "Export Scores",
            ASSN_COPY_JOIN_URL: "Copy Join URL",
            NO_PERMISSIONS_ASSN_USER: "You do not have applicable assignment permissions",
            NO_PERMISSIONS_ASSN_ACCT: "Assignment's account does not have applicable permissions",
            NO_JOIN_URL_LINK: "Assignment type does not use Join URL",
            NOT_AVAIL_FOR_ASSN_TYPE: "Not available for assignment type",
            UP_TO_COURSE: "Up to course",
        },
        attempt: {
            ATTEMPT: "Attempt",
            ATTEMPTS: "Attempts",
            FORCED: "Forced",
            FORCE_COMPLETED: "Force Completed",
            FORCE_COMPLETED_CN_DESCRIPTION: "Attempts are marked as force completed when they are incomplete and a subsequent attempt is started. Force completed attempts may not have scores for Analytics Categories and cannot be reviewed.",
            FORCE_COMPLETED_VA_DESCRIPTION: "Attempts are marked as force completed when they are incomplete and a subsequent attempt is started. Force completed attempts may not have scores for Analytics Categories and cannot be reviewed.",
            VIEW_HISTORY: "View attempt history",
            PERCENT_COMPLETE: "Percent Complete",
            SCORE: "Score",
        },
        analytics: {
            COUNT_NON_EMPTY_ASSN: "Assignments Created (Active)",
            assn_stats_charts: {
                SHOW_DATA_FOR_CATEGORY: "Show Data For Category",
                HIDE_DATA_FOR_CATEGORY: "Hide Data For Category",
                STARTED_TITLE: "Started",
                STARTED_DESC: "The number of students that have started the assignment.",
                STARTED_TABLE_CAP: "Student assignment start status",
                COMPLETED_TITLE: "Completed",
                COMPLETED_DESC: "The number of students that have completed the assignment.",
                COMPLETED_TABLE_CAP: "Student assignment completion status",
                TP_TITLE: "Time Played",
                TP_DESC: "The time played distribution for all student attempts and average time per attempt.",
                TP_TABLE_CAP: "Student assignment time played",
                TP_TABLE_SUMMARY_ROW: "Average time played",
                SCR_TITLE: "Score",
                SCR_DESC: "The score distribution for all student attempts and the average score for all attempts.",
                SCR_TABLE_CAP: "Student assignment scores",
                SCR_TABLE_SUMMARY_ROW: "Average score",
                CPS_TITLE: "Completed/Student",
                CPS_DESC: "The distribution of number of attempts completed to student count and average completed attempts per student.",
                CPS_TABLE_CAP: "Student counts by completed assignment attempts",
                CPS_TABLE_SUMMARY_ROW: "Average completed attempts",
            },
            time_played_ranges: {
                "0-5": "< 5 min.",
                "5-10": "5 - 10 min.",
                "10-15": "10 - 15 min.",
                "15-20": "15 - 20 min.",
                "20-": "> 20 min.",
                "0-30": "< 30 min.",
                "30-60": "30 min. - 1 hr.",
                "60-120": "1 - 2 hrs.",
                "120-": "> 2 hrs.",
            },
            score_ranges: {
                "90-100": "90-100",
                "80-89": "80-89",
                "70-79": "70-79",
                "60-69": "60-69",
                "50-59": "50-59",
                "40-49": "40-49",
                "30-39": "30-39",
                "20-29": "20-29",
                "10-19": "10-19",
                "0-9": "0-9",
            },
            question_type: {
                abbrev: {
                    MCQ: "MCQ",
                    FIBQ: "FITB",
                    ATAQ: "SATA",
                    CATQ: "CAT",
                    LIKERT: "LIKE",
                    RANKED: "RANK",
                    MATCH: "MAT",
                    sub_type: {
                        FIBQA: "FITB-A",
                        FIBQS: "FITB-S",
                    },
                },
            },
            question_quality: {
                FACT: "Factual",
                OPINION: "Opinion",
            },
            overview: {
                FROM_PROJ_TO_ACT_LINK: "Activity analytics for project",
                DET_ACT_ANALYTICS: "Detailed Activity Analytics",
                channel_authoring_details: {
                    SECTION_HEADING: "Authoring",
                    PROJECTS: "Projects",
                    ACTIVITIES: "Activities",
                    MEMBERS: "Members",
                    COLLABORATORS: "Collaborators",
                },
                channel_assn_analytics_overview: {
                    SECTION_HEADING: "Assignments",
                    ASSIGNMENTS: "Assignments",
                    ATTEMPTS: "Attempts",
                    ATT_STARTED: "Attempts Started",
                    ATT_COMPLETED: "Attempts Completed",
                    TOTAL_TIME_PLAYED: "Total Time Played",
                    AVG_TIME_PLAYED: "Avg. Time Played",
                    TP_DIST: "Time Played Distribution",
                },
                activity_details: {
                    SECTION_HEADING: "Activity Details",
                },
                playthrough_stats: {
                    SECTION_HEADING: "Activity Playthrough Stats",
                },
                project_details: {
                    SECTION_HEADING: "Project Details",
                },
                assignments_overview: {
                    SECTION_HEADING: "Assignments",
                },
                assignment_stats: {
                    SECTION_HEADING: "Assignment Stats",
                    OPT_SUB_HEADING: "Select a date range",
                    UPDATE_PROMPT: "Select a date range and update to view assignment stats",
                    UPDATE_RANGE_CLEAN_TT: "Select a new date range prior to updating",
                    general_stats: {
                        SECTION_HEADING: "General",
                        SUB_HEADING: "General assignment statistics for the date range",
                    },
                    new_students: {
                        SECTION_HEADING: "New Students",
                        SUB_HEADING: "Student accounts created during the date range which are taking assignments in this organization",
                        NO_RECORDS_MSG: "No new students",
                        STUDENT_COUNT: "Student Count",
                        DATE: "Date",
                    },
                    student_details: {
                        SECTION_HEADING: "Student Details",
                        SUB_HEADING: "Student accounts created on the selected date",
                        LAST_NAME: "Last Name",
                        FIRST_NAME: "First Name",
                        EMAIL: "Email",
                        CREATED_DATE: "Created Date",
                        SELECT_PROMPT: "Select a date in the New Students chart to view student information.",
                    }
                },
                activity_stats: {
                    SECTION_HEADING: "Activity Stats",
                    PUB_SECTION_HEADING: "Published Activities",
                    PUB_SECTION_DESC: "Published activities by template",
                    TABLE_TEMPLATE_COL: "Template",
                    TABLE_PUB_ACT_COL: "Published Activities",
                    NO_RECORDS_MSG: "No published activities",
                },
                share_stats: {
                    SECTION_HEADING: "Sharing Stats",
                    UPDATE_PROMPT: "Select a date range and update to view share stats",
                    UPDATE_RANGE_CLEAN_TT: "Select a new date range prior to updating",
                    TOTAL_UNIQUE_SHARES: "Total Unique Shares",
                    TOTAL_SHARES: "Total Shares",
                },
                assignment_table: {
                    SECTION_HEADING: "Assignments",
                    POLICY: "Policy",
                    ATTEMPTS: "Attempts",
                    TIME_PLAYED: "Time Played",
                    SCORE: "Score",
                    NAME: "Name",
                    COURSE: "Course",
                    CREATE_DATE: "Create Date",
                    STUDENTS: "Students",
                    SCORING: "Scoring",
                    LAST_ATTEMPT: "Last Attempt",
                    STARTED: "Started",
                    COMPLETED: "Completed",
                    TOTAL_TP: "Total",
                    AVG_TP: "Avg.",
                    AVG_SCR: "Avg.",
                },
                short_course: {
                    SELECTOR_SECTION_TITLE: "Courses",
                    SELECTOR_TITLE_HEADING: "Title",
                    SELECTOR_CI_HEADING: "Course Instances",
                    SELECTOR_STUDENTS_HEADING: "Students",
                    SELECTION_PROMPT: "Select a course from the list",
                    DETAILS_TITLE: "Course Details",
                    PLAYTHROUGH_TITLE: "Course Playthrough Stats",
                    INSTANCE_STATS_TITLE: "Course Instance Stats",
                    INSTANCE_LIST_TITLE: "Course Instances",
                    stats_chart: {
                        COMPLETED_TITLE: "Completed",
                        COMPLETED_DESC: "The total number of times this course has been completed and the % completion rate",
                        TIME_PLAYED_TITLE: "Average Time Played",
                        TIME_PLAYED_DESC: "The average time it took to complete this course (hh:mm:ss)",
                    },
                    range_chart: {
                        INSTANCES_CREATED: "Instances Created",
                        STARTED_ATTEMPTS: "Started Attempts",
                        ACTIVE_STUDENTS: "Active Students",
                    },
                    instance_table: {
                        ATTEMPTS: "Attempts",
                        TIME_PLAYED: "Time Played",
                        NAME: "Name",
                        CREATE_DATE: "Create Date",
                        STUDENTS: "Students",
                        LAST_ATTEMPT: "Last Attempt",
                        STARTED: "Started",
                        COMPLETED: "Completed",
                        TOTAL_TP: "Total",
                        AVG_TP: "Avg.",
                    },
                },
                export: {
                    PROJ_ACT_EXPORT_HEADING: "Export Activity Analytics",
                    RETRIEVE_DATA: "Retrieve Data For Date Range",
                    DATA_RETRIEVED_RANGE: "Data retrieved for date range:",
                    EXPORT_GUIDANCE: "Click Export button to generate CSV",
                    DATA_RETRIEVING_SELF: "Retrieving...",
                    DATA_RETRIEVING_OTHER: "Retrieving data for another project. Please wait for that request to finish prior to retrieving for this project",
                    CSV_HEAD_ACT_NAME: "Activity",
                    CSV_HEAD_ASSN_CREATED: "Assignments Created",
                    CSV_HEAD_ASSN_ACTIVE: "Assignments Created (Active)",
                    CSV_HEAD_STARTED_ATT: "Started Attempts",
                    CSV_ACTIVE_STUD: "Active Students",
                },
                completion_act_stats_export: {
                    HEADING: "Activity Completion Stats Export",
                    DESC: "This export provides a summary of activity statistics for the selected date range.",
                    EXPORT_BUTTON: "Export CSV",
                    NO_DATA: "No data available for the selected date range.",
                    CSV_HEAD_STUD_F_NAME: "First Name",
                    CSV_HEAD_STUD_L_NAME: "Last Name",
                    CSV_HEAD_STUD_EMAIL: "Email",
                    CSV_HEAD_TIME_PLAYED: "Time Played",
                    CSV_HEAD_SCORE: "Score",
                    DATA_RETRIEVING_OTHER: "Retrieving data for another activity. Please wait for that request to finish prior to retrieving for this activity",
                    EXPORT_GUIDANCE_NO_RES: "No completed attempts found for this activity in the selected date range.",
                },
            },
            new_students: {
                share: {
                    HEADING: "Student Monthly Share Report",
                    TOTAL_PROJS: "Total Projects",
                    TOTAL_PROJS_TT: "Number of projects with recorded share launches for specified month.",
                    TOTAL_ACTS: "Total Activities",
                    TOTAL_ACTS_TT: "Number of activities with recorded share launches for specified month.",
                    TOTAL_UNIQUE_SHARES: "Total Unique Shares",
                    TOTAL_UNIQUE_SHARES_TT: "For the specified month, the count of unique share launches per project, summed across all projects. Uniqueness is determined by IP address.",
                    TOTAL_SHARES: "Total Shares",
                    TOTAL_SHARES_TT: "For the specified month, the count of non-unique share launches per project, summed across all projects.",
                    ADMIN_ACT_HEADING: "Activity Accessors (Admin)",
                    ADMIN_ACT_BUTTON: "Load for current activity/month",
                    ADMIN_PROJ_HEADING: "Project Accessors (Admin)",
                    ADMIN_ACCESS_UNLOADED: "No accessors loaded",
                    ADMIN_PROJ_BUTTON: "Load for current project/month",
                    NO_SHARE_FOR_PERIOD: "No recorded shares for this period",
                    PROJ_TABLE_HEADING: "Project Shares",
                    ACT_TABLE_HEADING: "Activity Shares",
                    DOWNLOAD_ACCESSOR_CSV: "Download accessor CSV",
                    PROJ_ACCESSOR_CSV_PREFIX: "project_shares_accessors_",
                    ACT_ACCESSOR_CSV_PREFIX: "activity_shares_accessors_",
                    DOWNLOAD_PROJ_SHARE_CSV: "Download project shares CSV",
                    PROJ_SHARE_CSV_PREFIX: "project_shares_",
                    DOWNLOAD_ACT_SHARE_CSV: "Download activity shares CSV",
                    ACTS_SHARE_CSV_PREFIX: "activity_shares_in_project_",
                    proj_table: {
                        PROJECT_NAME: "Project Name",
                        FIRST_ACCESS_DATE: "First Access Date",
                        UNIQUE_SHARES: "Unique Shares",
                        TOTAL_SHARES: "Total Shares",
                    },
                    act_table: {
                        ACTIVITY_TITLE: "Activity Title",
                        FIRST_ACCESS_DATE: "First Access Date",
                        UNIQUE_SHARES: "Unique Shares",
                        TOTAL_SHARES: "Total Shares",
                    },
                    accessor_table: {
                        IP_ADDRESS: "IP Address",
                        FIRST_ACCESS_DATE: "First Access Date",
                        TOTAL_ACCESSES: "Total Accesses",
                    }
                }
            },
            action_history: {
                ACTION_HISTORY: "Action History",
                ACTIONS_LAST_7_DAYS: "Actions for the last 7 days",
                ACTIONS_LAST_30_DAYS: "Actions for the last 30 days",
                ACTIONS_LAST_60_DAYS: "Actions for the last 60 days",
                ACTIONS_LAST_90_DAYS: "Actions for the last 90 days",
                ACTIONS_ALL: "Actions for all time",
            },
            day_ranges: {
                LAST_7_DAYS: "Last 7 Days",
                LAST_30_DAYS: "Last 30 Days",
                LAST_60_DAYS: "Last 60 Days",
                LAST_90_DAYS: "Last 90 Days",
                ALL: "All",
            },
            user_actions: {
                ACTIVITY_CREATE: "Create Activity",
                ACTIVITY_EDIT: "Edit Activity",
                ACTIVITY_SAVE: "Save Activity",
                ACTIVITY_RENAME: "Rename Activity",
                ACTIVITY_PUBLISH: "Publish Activity",
                ACTIVITY_UNPUBLISH: "Unpublish Activity",
                ACTIVITY_DELETE: "Delete Activity",
                ACTIVITY_MOVE: "Move Activity",
                ACTIVITY_COPY: "Copy Activity",
                ACTIVITY_ATTACH_I_TAG: "Attach Activity Integration Tag",
                ACTIVITY_REMOVE_I_TAG: "Remove Activity Integration Tag",
                ACTIVITY_ATTACH_M_TAG: "Attach Activity Meta Tag",
                ACTIVITY_REMOVE_M_TAG: "Remove Activity Meta Tag",
                ACTIVITY_CREATE_LOCAL_ASSN: "ACTIVITY_CREATE_LOCAL_ASSN",
                PROJECT_CREATE: "Create Project",
                PROJECT_ADD_COLLAB: "Add Project Collaborator",
                PROJECT_EDIT_COLLAB: "Edit Project Collaborators",
                PROJECT_REMOVE_COLLAB: "Remove Project Collaborator",
                PROJECT_RENAME: "Rename Project",
                PROJECT_COPY: "Copy Project",
                PROJECT_MOVE: "Move Project",
                PROJECT_DELETE: "Delete Project",
                PROJECT_ATTACH_I_TAG: "PROJECT_ATTACH_I_TAG",
                PROJECT_REMOVE_I_TAG: "PROJECT_REMOVE_I_TAG",
                PROJECT_ADDED_AS_COLLABORATOR: "Added to project",
                PROJECT_REMOVED_AS_COLLABORATOR: "Removed from project",
                PROJECT_ROLE_CHANGED: "Project role changed",
                CHANNEL_FOLDER_CREATE: "Create Folder",
                CHANNEL_EXPORT_I_TAGS: "CHANNEL_EXPORT_I_TAGS",
                CHANNEL_IMPORT_I_TAGS: "CHANNEL_IMPORT_I_TAGS",
                CHANNEL_ADD_I_TAG: "CHANNEL_ADD_I_TAG",
                CHANNEL_DELETE_I_TAG: "CHANNEL_DELETE_I_TAG",
                CHANNEL_EDIT_I_TAG: "CHANNEL_EDIT_I_TAG",
                CHANNEL_EXPORT_M_TAGS: "CHANNEL_EXPORT_M_TAGS",
                CHANNEL_IMPORT_M_TAGS: "CHANNEL_IMPORT_M_TAGS",
                CHANNEL_ADD_M_TAG: "CHANNEL_ADD_M_TAG",
                CHANNEL_DELETE_M_TAG: "CHANNEL_DELETE_M_TAG",
                CHANNEL_EDIT_M_TAG: "CHANNEL_EDIT_M_TAG",
                CHANNEL_ADD_PP_TAG: "CHANNEL_ADD_PP_TAG",
                CHANNEL_DELETE_PP_TAG: "CHANNEL_DELETE_PP_TAG",
                CHANNEL_EDIT_PP_TAG: "CHANNEL_EDIT_PP_TAG",
                ORG_ADDED_TO: "Added to Organization",
                ORG_REMOVED_FROM: "Removed from Organization",
                ORG_ROLE_CHANGED: "Organization role changed",
                ACCOUNT_EDIT_DISP_NAME: "Change Account Display Name",
                ACCOUNT_EDIT_PASSWORD: "Change Account Password",
                ACCOUNT_EDIT_EMAIL: "Change Account Email",
                ACCOUNT_EDIT_SHARE_POLICY: "ACCOUNT_EDIT_SHARE_POLICY",
                ACCOUNT_ADD_BADGE_SERVICE: "ACCOUNT_ADD_BADGE_SERVICE",
                ACCOUNT_EDIT_BADGE_SERVICE: "ACCOUNT_EDIT_BADGE_SERVICE",
                ACCOUNT_ADD_BADGE_TEMPLATE: "ACCOUNT_ADD_BADGE_TEMPLATE",
                ACCOUNT_ADD_SKILL_SERVICE: "ACCOUNT_ADD_SKILL_SERVICE",
                ACCOUNT_EDIT_SKILL_SERVICE: "ACCOUNT_EDIT_SKILL_SERVICE",
                ASSN_EDIT_DATES: "ASSN_EDIT_DATES",
                ASSN_EDIT_SCORE_TYPE: "ASSN_EDIT_SCORE_TYPE",
                ASSN_EDIT_NUM_ATT: "ASSN_EDIT_NUM_ATT",
                ASSN_START_ATTEMPT: "ASSN_START_ATTEMPT",
                ASSN_COMPLETE_ATTEMPT: "ASSN_COMPLETE_ATTEMPT",
                COURSE_CREATE: "Create Course",
                COURSE_EDIT: "Edit Course",
                COURSE_SAVE: "Save Course",
                COURSE_PUBLISH: "Publish Course",
                COURSE_UNPUBLISH: "Unpublish Course",
                COURSE_RENAME: "Rename Course",
                COURSE_DELETE: "Delete Course",
                COURSE_COPY: "Copy Course",
                COURSE_MOVE: "Move Course",
                COURSE_INST_CREATE_LOCAL: "Create Local Course Instance",
                COURSE_INST_START_ATTEMPT: "Course Instance Attempt Start",
                COURSE_INST_PROGRESS_ATTEMPT: "Course Instance Attempt Progress",
                COURSE_INST_COMPLETE_ATTEMPT: "Course Instance Attempt Complete",
                GROUP_CREATE: "Create Group",
                GROUP_RENAME: "Rename Group",
                GROUP_ADD_USER: "Add User to Group",
                GROUP_REMOVE_USER: "Remove User from Group",
                USER_LOGIN: "Login",
            },
        },
        privacy_policy: {
            MANAGE_PP: "Manage Privacy Policies",
            NO_POLICIES: "No Privacy Policies have been created",
            ADD_PP: "Add Privacy Policy",
            EDIT_PP: "Edit Privacy Policy",
            NEW_PP: "New Privacy Policy",
            DELETE_PP: "Delete Privacy Policy",
            INVALID_ID: "Invalid Privacy Policy ID",
            DEFAULT_PP_NAME: "New Privacy Policy",
            DEFAULT_PP_START_TITLE: "Privacy Policy Pre-Activity Title",
            DEFAULT_PP_START_BODY: "New Privacy Policy Pre-Activity Body",
            DEFAULT_PP_START_LABEL_ADVANCE: "Ok",
            DEFAULT_PP_END_TITLE: "New Privacy Policy Post-Activity Title",
            DEFAULT_PP_END_BODY: "New Privacy Policy Post-Activity Body",
            DEFAULT_PP_END_LABEL_SHARE: "Share",
            DEFAULT_PP_END_LABEL_DO_NOT_SHARE: "Do Not Share",
            POLICY_NAME_LABEL: "Privacy Policy Name",
            POLICY_NAME_TT: "Internal privacy policy name. This is not instructor or student facing.",
            POLICY_START_NAME: "Pre-Activity Privacy Policy",
            POLICY_START_DESC: "Pre-Activity Privacy Policy description",
            POLICY_START_ENABLED: "Pre-Activity Privacy Policy Enabled",
            POLICY_END_NAME: "Post-Activity Privacy Policy",
            POLICY_END_DESC: "Post-Activity Privacy Policy description",
            POLICY_END_ENABLED: "Post-Activity Privacy Policy Enabled",
            POLICY_START_TITLE_LABEL: "Title",
            POLICY_START_TITLE_TT: "Student/instructor facing privacy policy name. (optional)",
            POLICY_START_BODY_LABEL: "Privacy Policy Body",
            POLICY_START_BODY_TT: "Student/instructor facing privacy policy content. Use Markdown for styling (required)",
            POLICY_START_LABEL_ADVANCE_LABEL: "Pre-Activity Acknowledgement Label",
            POLICY_START_LABEL_ADVANCE_TT: "Label for acknowledgement UI presented to the user for Pre-Activity Privacy Policy. Ex: button labeled 'Ok' (required)",
            POLICY_END_TITLE_LABEL: "Title",
            POLICY_END_TITLE_TT: "Student/instructor facing privacy policy name. (optional)",
            POLICY_END_BODY_LABEL: "Privacy Policy Body",
            POLICY_END_BODY_TT: "Student/instructor facing privacy policy content. Use Markdown for styling (required)",
            POLICY_END_LABEL_SHARE_LABEL: "Post-Activity Share Label",
            POLICY_END_LABEL_SHARE_TT: "Label for UI presented to the user in Post-Activity Privacy Policy. Users will use this button when they wish to share their data. Ex: button labeled 'Share' (required)",
            POLICY_END_LABEL_DO_NOT_SHARE_LABEL: "Post-Activity Acknowledgement Label",
            POLICY_END_LABEL_DO_NOT_SHARE_TT: "Label for UI presented to the user in Post-Activity Privacy Policy. Users will use this button when they DO NOT wish to share their data. Ex: button labeled 'Do Not Share' (required)",
            CONFIRM_NEW_LABEL: "Add",
            CONFIRM_EDIT_LABEL: "Confirm Edit",
            CONFIRM_DELETE_WARNING: "Are you sure you want to delete this privacy policy? This cannot be undone.",
            CONFIRM_DELETE_WARNING_ACTS: "This privacy policy will become unavailable for attached activities.",
            CONFIRM_DELETE_WARNING_ACT_COUNT: "Number of attached activities:",
        },
        RSD: {
            RSD_SERVICES_LABEL: "Skill Services",
            ADD_RSD_SERVICE: "Add Skill Service",
            RSD_SERVICE_LABEL: "Skill Taxonomy",
        },
        page_title: {
            DEFAULT: 'Author',
            SIGN_UP: 'Register',
            FORGOT_PASSWORD: 'Forgot Password',
            T_AND_C: 'Terms and Conditions',
            PRIVACY: 'Privacy Policy',
            DASHBOARD: 'Dashboard',
            ACCOUNT_SETTINGS: 'Account Settings',
            SUBSCRIPTION: 'Subscription',
            ADMIN: 'Admin',
            NOT_FOUND: 'Not Found',
            CHANNEL_ANALYTICS: 'Channel Analytics',
            CHANNEL_PROJECT_ANALYTICS: "Channel Project Analytics",
            PROJECT_VIEW: 'Project',
            PROJECT_ANALYTICS_VIEW: "Project Analytics",
            PROJECT_COLLABS_VIEW: "Project Collaborators",
            PROJECT_ACTIVITY_ANALYTICS: "Project Activity Analytics",
            PROJECT_COURSE_ANALYTICS: "Project Course Analytics",
            ACTIVITY_VIEW: 'Activity',
            ACTIVITY_CREATE_VIEW: 'Create Activity',
            ACTIVITY_PREVIEW: 'Activity Preview',
            ACTIVITY_EDIT: 'Edit Activity',
            ACTIVITY_REVIEW: 'Review Activity',
            ACTIVITY_META_TAGS: 'Activity Meta Tags',
            ACTIVITY_ANALYTICS: 'Activity Analytics',
            ACTIVITY_QLA: 'Question-level Analytics',
            GROUPS: 'Groups',
            ACTIVITY_SHARE: 'Shared Activity',
            connect: {
                DEFAULT: 'Connect',
                CREATE_ASSN: 'Create Assignment',
                EDIT_ASSN: 'Edit Assignment',
                POLICY_ASSN: 'Modify Assignment Policy',
                LAUNCH_ASSN: 'Launch Assignment',
                PLAY_ASSN: 'Play Assignment',
                STUD_PREVIEW: 'Student Preview',
                INST_REPORT: 'Report',
                INST_ACT_ANALYTICS: 'Activity Details',
                STUD_REPORT: 'Report',
                COURSE_VIEW: 'Course',
                INST_REVIEW: 'Review',
                STUD_REVIEW: 'Review',
                COOKIE_TS: 'Cookie Troubleshooting',
                UNAVAILABLE: 'Unavailable',
                ERROR: 'Error',
                NOT_FOUND: 'Not Found',
            },
            lti: {
                DEFAULT: 'Assignment',
                CREATE_ASSN: 'Create Assignment',
                POLICY_ASSN: 'Modify Assignment Policy',
                PLAY_ASSN: 'Play Assignment',
                STUD_PREVIEW: 'Student Preview',
                INST_REVIEW: 'Review',
                COURSE_VIEW: 'Course',
                SKILLBUILD: 'SkillBuild',
                UNAUTHORIZED: 'Unauthorized',
                UNAVAILABLE: 'Unavailable',
                COOKIE_TS: 'Cookie Troubleshooting',
                NOT_FOUND: 'Not Found',
            },
            vantage: {
                DEFAULT: 'Assignment',
                CREATE_ASSN: 'Create Assignment',
                POLICY_ASSN: 'Modify Assignment Policy',
                LAUNCH_ASSN: 'Launch Assignment',
                PLAY_ASSN: 'Play Assignment',
                STUD_PREVIEW: 'Student Preview',
                INST_REPORT: 'Report',
                STUD_REPORT: 'Report',
                INST_REVIEW: 'Review',
                STUD_REVIEW: 'Review',
                UNAUTHORIZED: 'Unauthorized',
                UNAVAILABLE: 'Unavailable',
                COOKIE_TS: 'Cookie Troubleshooting',
                NOT_FOUND: 'Not Found',
                QLA: 'Question-level Analytics',
            },
        },
        user: {
            local_role_type: {
                AUTHOR: 'Author/Instructor',
                STUDENT: 'Student',
            },
            account_features: {
                useVoiceSynthesis: 'Enable AWS Polly Voice Synthesis',
                useVoiceSynthesisMistral: 'Enable Mistral Voice Synthesis (Not implemented)',
                useVoiceSynthesisElevenLabs: 'Enable ElevenLabs Voice Synthesis',
                useVoiceSynthesisCartesia: 'Enable Cartesia Voice Synthesis',
                useChatBot: 'Enable AI Features',
                mcgrawWebsketch: 'Enable McGraw Websketches',
                mcgrawGasparVideo: 'Enable McGraw Gaspar Video',
                shortCourseAuthoring: 'Enable Short Course Authoring',
                EDLCustomExport: 'Enable EDL Custom Export',
            },
            account_type: { // TODO: get FINAL marketing names for these
                FREE: "Basic",
                FREE_V2: "Basic",
                INDIVIDUAL: "Personal",
                SCHOOL: "Team",
                ENTERPRISE: "Enterprise",
            },
            account_type_admin: { // admin-facing names
                FREE: "Basic v1",
                FREE_V2: "Basic v2",
                INDIVIDUAL: "Personal",
                SCHOOL: "Team",
                ENTERPRISE: "Enterprise",
            },
            profile: {
                FIRST: "First name",
                LAST: "Last name",
                DISPLAY: "Display name",
                EMAIL: "Email address",
                PASSWORD: "Password",
                PRO_AFF: "Professional affiliation",
                AVATAR: "Avatar",
                BUILD_GOAL: "What would you like to build?",
            },
            settings: {
                SAVE_BTN_LBL: "Save changes",
            },
        },
        signed_out: {
            TAGLINE_1: "Two Great Learning Technologies",
            TAGLINE_2: "One Location",
            CTA: "Please register so we can provide you with more information about either of these great experiences.",
            LOGO_MESSAGE: "Design and deploy cutting edge learning solutions. Get started today.",
            LOGO_MESSAGE_SB: "Learn, practice, and credential vital durable human skills.",
            FORGOT_PW: "forgot your password?",
            NOT_REGISTERED: "not registered?",
            ALREADY_REGISTERED: "already registered?",
            TERMS_OF_USE: "Terms of Use",
            PRIVACY_POLICY: "Privacy Policy",
            CONTACT_US: "Contact Us",
            sign_in: {
                SIGN_IN: "sign in",
                EMAIL: "email address",
                PASSWORD: "password",
                REMEMBER_ME: "remember me",
                SIGN_IN_BTN_LBL: "sign in",
            },
            sign_in_new: {
                promo: {
                    product: "AUTHOR",
                    TAGLINE: "Your platform for roleplay assessments and learning solutions.",
                    SLUG_1: "Create immersive roleplay assessments",
                    SLUG_2: "Customize for your use case",
                    SLUG_3: "Deliver to your LMS in minutes",
                    TRAILER: "Design pedagogically sound content • Boost authentic, experiential learning.",
                    social: {
                        LINKEDIN: "Muzzy Lane on LinkedIn",
                        YOUTUBE: "Muzzy Lane on YouTube",
                        FACEBOOK: "Muzzy Lane on Facebook",
                        X: "Muzzy Lane on X",
                    }
                },
                form: {
                    SIGN_IN: "Sign in",
                    WELCOME: "Welcome back. Pick up where you left off.",
                    EMAIL: "Email address",
                    PASSWORD: "Password",
                    REMEMBER_ME: "Remember me",
                    FORGOT: "Forgot your password?",
                    NEW_USER: "New user - contact us →"
                },
                forgot_form: {
                    EMAIL: "Email address",
                    REQ_RESET: "Request Password Reset",
                    REQ: "Request",
                    SIGN_IN_LINK: "Sign in",
                    RESET_PASSWORD: "Update Password",
                    NEW_PASSWORD: "New password",
                    NEW_PASSWORD_CONFIRM: "Confirm new password",
                    RESET_PASSWORD_BTN_LBL: "Update my password",
                },
                signup_form: {
                    EMAIL: "Email address",
                    CONFIRM_EMAIL: "Confirm email address",
                    REGISTER_BTN_LBL: "Register",
                    ALREADY_REGISTERED: "Already registered?",
                    NEWSLETTER_MSG: "Your Author account includes access to Author news and details about updates. You may unsubscribe from these updates after first receipt.",
                }
            },
            register_new: {
                PW_LBL: "Create new password",
                PW_PH: "At least 8 characters",
                PW_CONFIRM_LBL: "Confirm new password",
                PW_CONFIRM_PH: "Re-enter password",
                FIRST_LBL: "First name",
                FIRST_PH: "",
                LAST_LBL: "Last name",
                LAST_PH: "",
                DISP_LBL: "Display name",
                DISP_PH: "How your name appears to others",
                DISP_ORG_LBL: "Display name",
                DISP_ORG_PH: "How organization name appears to others",
                EMAIL_LBL: "Work email",
                EMAIL_PH: "",
                PRO_AFF_LBL: "Professional affiliation",
                PRO_AFF_PH: "Employer",
                BUILD_Q_LBL: "What would you like to build?",
                BUILD_Q_PH: "A few words about your assessment goals",
                CONTACT_LBL: "I agree to be contacted by Muzzy Lane about Author, including product updates and marketing communications",
                NEWSLETTER_LBL: "Send me the Muzzy Lane newsletter",
                VERIFY_BTN_LBL: "Verify & continue →",
                ORG_REG_COMPLETE: "Organization Registration Complete",
                ORG_REG_COMPLETE_SIGN_IN_PROMPT: "Please sign in as the organization administrator.",
                promo: {
                    TAGLINE: "Verify your account",
                    TAGLINE_SUB: "Confirm who you are and set a password to finish setting up your profile.",
                    TAGLINE_ORG: "Complete organization registration",
                    TAGLINE_SUB_ORG: "Confirm details and finish setting up your organization account.",
                }
            },
        },
        ai: {
            useCaseDisplayNames: {
                OPEN_RESPONSE: 'Open Response Analysis',
                GENERATE_CONTENT: 'Content Generation',
                AI_TUTOR: 'AI Tutor',
            }
        },
        featured_demo: {
            FEATURED_DEMOS: "Featured Demos",
            admin: {
                MANAGE_DESC: "Manage the featured demos that are displayed on the home page.",
                ADD_TITLE: "Add Featured Demo",
                ADD_DESC: "Add a new featured demo to the home page. New featured demo is disabled by default.",
                ADD_FORM_NOVA_ACT_ID: "Nova Activity ID",
                SELECTED_FD: "Selected Featured Demo",
                CONFIRM_DELETE: "Are you sure you want to delete this featured demo?",
                WARN_ALREADY_GETTING: "Already getting featured demos",
            }

        },
        ELEVENLABS_ENGINES: {
            eleven_v3: "11Labs v3",
            eleven_flash_v2_5: "11Labs flash_v2_5",
        },
        CARTESIA_ENGINES: {
            'sonic-3.5': "Cartesia sonic-3.5",
        }
        
    } // en
};